import { Component, OnInit, Inject, ElementRef, ViewChild, OnChanges, SimpleChanges, signal } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from '@app/services/orders/order.service';
import {
  BatchRatesTableButtonEventData,
  BatchRatesTableDropDownOnClickData,
  BOX_ID_NAME_FIELD,
  DEFAULT_SERVICE_LEVEL_NAME,
  DeliveryTimeStatus,
  DELIVERY_TIME_STATUS_ORDER,
  ProccessedSingleOrderRate,
  SERVICE_LEVEL_NAME_FIELD,
} from '@app/services/order-batch/order-batch-rates.model';
import {
  IAllServiceLevelsRates,
  IAllOrderRates,
  IOrderBatchRateInfo,
  IOrderRatesMessages,
} from '@pdqdev/pdq-shared/dist/interfaces';
import { OrderBatch } from '@app/services/order-batch/order-batch.model';
import { Order } from '@app/services/order/order.model';
import { PrintService } from 'src/app/dashboard/print/services/print.service';
import { CurrencySign, CurrencyUnit, ShipmentCreationErrorCode } from '@pdqdev/pdq-shared/dist/entities';
import { getSignOfCurrency } from 'src/utils/localization-utils';
import { isNumber } from 'src/utils/number-utils';
import { getRawDatesDifferenceInDays, TimeUnits } from 'src/utils/times-utils';
import { OrderBatchService } from '../../../../../services/order-batch/order-batch.service';
import {
  columnsConfigs,
  DropdownOption,
  SaveAsBatchColumnSettings,
  SaveAsBatchEventNames,
  SmartBatchColumnsProps,
} from '../../configs/saveasbatch-table.config';
import { ShopService } from '@app/services/shops/shop.service';
import {
  IBoxSizeData,
  IOrderMissingRatesDetails,
  IOrderRateDetails,
  IOrderSelectedBox,
  IOrderSelectedBoxMultiLabel,
  IServiceLevelChosenRates,
  IServiceLevelProviderChosenRates,
  IShipmentDeliveryDateEstimation,
} from '@pdqdev/pdq-shared/dist/interfaces';
import {
  generateConfirmChosenRatesData,
  isServiceLevelsEquals,
  mappingDisplayNameToServiceLevel,
} from '@pdqdev/pdq-shared/dist/utils';
import {
  carrierProviderDisplayNameMap,
  masterCarrierTypeNames,
  ServiceLevelDisplayNames,
  ServiceLevelToDisplayName,
  ServiceLevelToProviderDisplayName,
} from '@pdqdev/pdq-shared/dist/CarrierData';
import { SnackbarWrapperComponent } from '@app/sharedModule/components/snackbar-wrapper/snackbar-wrapper.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';

import { first } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { IShopMetadata } from '@pdqdev/pdq-shared/dist/interfaces/IShopMetadata';
import { Carrier, CarrierTypes } from '../../../../../services/carriers/carrier.model';
import { CurrencyRatesService } from '@app/services/currency-rates/currency-rates.service';
import { CurrencyRate } from '@app/services/currency-rates/currency-rate.model';
import { TextDialogComponent } from '@app/sharedModule/components/text-dialog/text-dialog.component';
import * as _ from 'lodash';
import { getOrderSplitIndicesString } from '@utils/order-split-utils';
import { PdqCheckboxComponent } from '@app/storybook/components/checkbox/checkbox.component';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { PdqToastComponent } from '@app/storybook/components/toast/toast.component';

const ERROR_TEXT = 'Error in calculation';
const NOT_AVAILABLE = 'N/A';

interface BoxesCachedRates {
  ordersRatesOptions?: Map<string, IOrderRateDetails[]>;
  selectedServiceLevelsRates: Map<string, TruncatedServiceLevelProviderRatesData[]>;
  selectedOrdersBoxes?: Map<string, IBoxSizeData>;
  selectedOrdersMessages?: Map<string, IOrderRatesMessages>;
}

interface TruncatedServiceLevelProviderRatesData {
  provider: string;
  ordersRatesDetails: IOrderRateDetails[];
  ordersMissingRatesDetails?: IOrderMissingRatesDetails[];
}

interface TruncatedServiceLevelRatesData {
  serviceLevel: string;
  ratesPerProviders: TruncatedServiceLevelProviderRatesData[];
}

interface TruncatedRatesData {
  ordersRatesOptions?: IAllOrderRates[];
  selectedServiceLevelsRates: TruncatedServiceLevelRatesData[];
  selectedOrdersBoxes?: IOrderSelectedBox[];
  ordersRatesMessages?: IOrderRatesMessages[];
}

interface OrderShippingAdditionalData {
  orderId: string;
  isSaturdayDelivery: boolean;
  isShouldTrySuggestedAddress: boolean;
  isTriedSuggestedAddress: boolean;
}

interface AnalyzedData {
  batchDeliveryPromiseStatus;
  batchTotalShipmentCost: string | null;
  ordersArrivingOnTimeCount: number;
  ordersUnknownDeliveryPromiseCount: number;
  ordersLateCount: number;
}
interface CarrierCachedData {
  name: string;
  type: CarrierTypes;
  currencySign: CurrencySign | null;
  isMACarrier: boolean;
  analyzedDataByProviders: Map<string /* provider name*/, AnalyzedData>;
  nonProvidersAnalyzedData?: AnalyzedData;
  totalRatesData: { value: any; text: string }[];
  currentDate: Date;
  selectedOffsetOption: number;
}

interface RatesRequestOptions {
  hoursOffset?: number;
  ignoreInternalRates?: boolean;
  carrierId?: number;
}

enum CarrierCachedFieldNames {
  NAME = 'name',
  TYPE = 'type',
  CUURENCY_SIGN = 'currencySign',
  ANALYZED_DATA_BY_PROVIDERS = 'analyzedDataByProviders',
  NON_PROVIDERS_ANALYZED_DATA = 'nonProvidersAnalyzedData',
  IS_MA_CARRIER = 'isMACarrier',
  TOTAL_RATED_DATA = 'totalRatesData',
  CURRENT_DATE = 'currentDate',
  SELECTED_OFFSET_SET_OPTION = 'selectedOffsetOption',
}

enum BatchDeliveryPromiseStatus {
  ONTIME = 'on_time',
  LATE = 'late',
  MIXED = 'mixed',
  UNKNOWN = 'unknown',
}

interface MatMenuListItem {
  carrierId: number;
  name: string;
  displayName: string;
  arrivingOnTimeDisplayString: string;
  arrivingOnTime: number;
  totalShipmentCost: number;
  totalShipmentCostDisplayString: string;
}

@Component({
  selector: 'pdq-save-as-batch-new',
  templateUrl: './save-as-batch-new.component.html',
  styleUrls: ['./save-as-batch-new.component.scss'],
  standalone: false,
})
export class SaveAsBatchNewComponent implements OnInit, OnChanges {
  readonly displayedColumns: string[] = ['CarrierName', 'OrderNumber', 'Amount'];
  readonly BatchDeliveryPromiseStatus = BatchDeliveryPromiseStatus;
  shopMetadata$: Observable<IShopMetadata>;

  @ViewChild('batchNameEditInput') batchNameEditInput: ElementRef;
  @ViewChild('saturdayCheckbox') saturdayCheckbox: PdqCheckboxComponent;

  currencySign: CurrencySign | null;
  confirming = false;

  batchDeliveryPromiseStatus = BatchDeliveryPromiseStatus.UNKNOWN;
  batchTotalShipmentCost: string | null;
  ordersArrivingOnTimeCount: number;
  ordersUnknownDeliveryPromiseCount: number;
  ordersLateCount: number;
  shopIanaTimezone: string;

  orderBatch: OrderBatch;
  rows: ProccessedSingleOrderRate[] = [];
  columns: SaveAsBatchColumnSettings[] = [...columnsConfigs];
  serviceLevelsRates: IServiceLevelChosenRates[];
  allOrdersRates: IAllOrderRates[];
  selectedRatesDetails: (IOrderRateDetails & { carrierId: number })[] = [];
  invalidOrdersRatesErrorMessages: { text: string; orderId: string; orderNumber: string; type: 'api' | 'default' }[] =
    [];
  processedErrorMessagesTexts: {
    ordersMissingRatesText?: string;
  };
  multiLabelSelectedOrderBoxes: IOrderSelectedBoxMultiLabel[];
  ordersMessages: IOrderRatesMessages[];
  isPerformingRatesRetry: boolean = false;

  // Data cache variables
  boxesRatesCache: Map<number, BoxesCachedRates>;
  carrierType: CarrierTypes;
  isMACarrier: boolean = false;
  totalRatesData = [];
  tabsConfigData = [];
  selectedProvider: string;
  selectedServiceLevel: string;

  // switch tabs log, temp log to backend
  recommendedCheapestQuickestLog: string | null = null;

  // Best match approach
  isBestMatch: boolean = false;
  selectedCarrierId: number;
  cachedDataByCarriers: Map<number /*CarrierId*/, CarrierCachedData> = new Map();
  rowsByCarriers: Map<number /*CarrierId*/, ProccessedSingleOrderRate[]> = new Map();
  allOrdersRatesByCarriers: Map<number /*CarrierId*/, IAllOrderRates[]> = new Map();
  serviceLevelsRatesByCarriers: Map<number /*CarrierId*/, IServiceLevelChosenRates[]> = new Map();
  missingBatchRatesByCarriers: Map<number /*CarrierId*/, boolean> = new Map();
  ordersMessagesByCarriers: Map<number /*CarrierId*/, IOrderRatesMessages[]> = new Map();
  supportMeasurementsByCarriers: Map<number /*CarrierId*/, boolean> = new Map();
  commonBoxesOptionsByCarriers: Map<number /*CarrierId*/, IBoxSizeData[]> = new Map();
  initialBoxesSelectionsByCarriers: Map<number /*CarrierId*/, IOrderSelectedBox[]> = new Map();
  lastCommonBoxesSelectionsByCarriers: Map<number /*CarrierId*/, IOrderSelectedBox[]> = new Map();
  currentBoxesSelectionsByCarriers: Map<number /*CarrierId*/, IOrderSelectedBox[]> = new Map();
  ordersParcelsOptionsByCarriers: Map<
    number /*CarrierId*/,
    { orderId: string; parcelsOptions: IBoxSizeData[] }[] | null
  > = new Map();
  multiLabelSelectedOrderBoxesByCarriers: Map<number /*CarrierId*/, IOrderSelectedBoxMultiLabel[]> = new Map();
  boxesRatesCacheByCarriers: Map<number /*CarrierId*/, Map<number, BoxesCachedRates>> = new Map();
  invalidOrdersRatesErrorMessagesByCarrier: Map<
    number /*CarrierId*/,
    { text: string; orderId: string; orderNumber: string; type: 'api' | 'default' }[]
  > = new Map();
  ordersShippingAdditionalDataByCarrier: Map<number /*CarrierId*/, OrderShippingAdditionalData[]> = new Map();
  tabsConfigDataByCarrier: Map<number /*carrierId*/, any[]> = new Map();

  carrierName: string;
  chargedShippingCost: number | null;
  itemsNumber: number;
  ordersCount: number | null;
  packagesCount: number | null;
  missingBatchRates = false;
  deletedOrdersIds: string[] = [];
  scheduledPickupIsSupported = true;

  // boxes management variables
  supportMeasurements = false;
  commonBoxesOptions: IBoxSizeData[] = [];

  initialBoxesSelections: IOrderSelectedBox[] = [];
  lastCommonBoxesSelections: IOrderSelectedBox[] = [];
  currentBoxesSelections: IOrderSelectedBox[] = [];

  selectedOffsetOption: number = 0;

  finalProvidersMenuOpened = false;
  shipmentDatesMenuOpened = false;

  isThursdaySaturdayDelivery = false;
  isFridaySaturdayDelivery = false;

  isUseOldDatePicker = false;
  startDate: Date;
  endDate: Date;
  currentDate: Date;
  daysRange = 60;
  datesRangeMilliseconds = 1000 * 60 * 60 * 24 * this.daysRange; // 60 days offset
  isShowSaturdayDeliveryOption = false;
  isSaturdayDeliveryChosen = false;

  isEmptyStateOn = false;

  userSelectedServiceLevel: string;
  userSelectedProvider: string;

  ordersShippingAdditionalData: OrderShippingAdditionalData[] = [];
  latestCurrencyRates: CurrencyRate[] = [];
  shopsCurency: CurrencyUnit = 'ILS';

  isRatesInitialized = false;
  forceFulfillScreenNavigate: boolean = false;

  userSelectedOrdersIds: string[] = [];
  isWaitingForBatchRemove: boolean = false;
  isShowSuggestedAddressesBanner: boolean = false;
  isColumnsFiltered;
  messageCodesToHide = [
    ShipmentCreationErrorCode.USED_SUGGESTED_ADDRESS,
    ShipmentCreationErrorCode.USAGE_OF_SUGGESTED_ADDRESS_REQUIRED,
  ];

  ordersParcelsOptions: { orderId: string; parcelsOptions: IBoxSizeData[] }[] | null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public acknowledgedialog: MatDialog,
    public dialogRef: MatDialogRef<SaveAsBatchNewComponent>,
    public innerDialogRef: MatDialog,
    private orderBatchService: OrderBatchService,
    private orderService: OrderService,
    private printService: PrintService,
    private currencyRatesService: CurrencyRatesService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private _shopService: ShopService,
    private toastService: ToastService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.orderBatch) {
      this.initCarrierType();
    }
  }

  async ngOnInit(): Promise<void> {
    try {
      this.orderBatch = this.data.batch;
      if (this.data?.addToBatchId) {
        this.isSaturdayDeliveryChosen = !!this.orderBatch.saturdayDelivery;
      }
      if (this.orderBatch.rateInfo) {
        // Subscribe to some specific carrier
        const orderBatchRatesData = this.orderBatch.rateInfo;
        await this.initializeBatchRatesData(orderBatchRatesData);
        if (this.isShouldRetryRates()) {
          this.retryFetchFailedRates(orderBatchRatesData);
        }
        await this.pollForRatesRetry(orderBatchRatesData);
      } else if (this.orderBatch.rateInfoList) {
        // Best match approach - retrieving rates for all carriers together
        const orderBatchRatesDataList = this.orderBatch.rateInfoList;
        await this.initializeBestMatchRatesData(orderBatchRatesDataList);
        // once we implmented the retry mechanism (best match version 2) we should adjust it to check all the carriers together

        // let relevantOrderBatchRatesData = orderBatchRatesDataList.find(orderBatchRatesData => orderBatchRatesData.carrier?.id == this.selectedCarrierId);
        // if (this.isShouldRetryRates()) {
        //   this.retryFetchFailedRates(relevantOrderBatchRatesData)
        // }
      }
    } catch (e) {
      console.log(`Failed to init received data. Error: ${e}`);
      throw e;
    }
  }

  isShouldRetryRates() {
    return this.rows?.length && this.rows.some((row) => row.isShouldTrySuggestedAddress || row.isApiErrorResponce);
  }

  async initializeBatchRatesData(orderBatchRatesData: IOrderBatchRateInfo) {
    this.initOrdersAdditionalShippingData();
    this.initCarrierType();
    await this.initShopService();
    await this.initLatestCurrencyRates();
    this.initializeNewEmptyCacheMap();
    this.initWindowTitle(this.orderBatch);
    this.initializeLocalizationData(orderBatchRatesData);
    this.initializeOrderBatchRatesData(orderBatchRatesData, this.orderBatch?.orders);
    this.proccessEmptyStateData();
    this.initializeTabsConfigData();
    this.initializeBasicBatchData();
    this.generateAnalyzedBatchData();

    this.startDate = new Date(Date.now());
    this.startDate.setHours(0, 0, 0, 0);

    this.initDateAndOffset(orderBatchRatesData);

    this.endDate = new Date(this.startDate.getTime() + this.datesRangeMilliseconds);
    this.isShowSaturdayDeliveryOption = this.checkIfSaturdayDeliveryOption();

    this.isRatesInitialized = true;
    this.performInitialSort();
  }

  async initializeBestMatchRatesData(orderBatchRatesDataList: IOrderBatchRateInfo[]) {
    this.isBestMatch = true;
    this.allOrdersRates = [];
    this.selectedRatesDetails = [];
    this.serviceLevelsRates = [];
    this.rows = [];
    await this.initShopService();
    await this.initLatestCurrencyRates();
    this.initializeNewEmptyCacheMap();
    this.initializeBasicBatchData();

    for (const [i, orderBatchRatesData] of orderBatchRatesDataList.entries()) {
      const carrier = orderBatchRatesData.carrier;
      this.initCarrierCached(carrier);
      this.initCarrierType(carrier);
      this.initOrdersAdditionalShippingData(carrier?.id);
      this.initializeLocalizationData(orderBatchRatesData);
      this.initializeOrderBatchRatesDataForBestMatch(orderBatchRatesData, this.orderBatch?.orders);
      this.initializeTabsConfigData(carrier?.id);
      this.initDateAndOffset(orderBatchRatesData, carrier);
    }

    this.startDate = new Date(Date.now());
    this.startDate.setHours(0, 0, 0, 0);
    this.endDate = new Date(this.startDate.getTime() + this.datesRangeMilliseconds);
    this.isShowSaturdayDeliveryOption = this.checkIfSaturdayDeliveryOption();

    this.initDefaultDataForBestMatch(orderBatchRatesDataList);

    this.proccessEmptyStateData();

    this.isRatesInitialized = true;
    this.performInitialSort();
  }

  initDefaultDataForBestMatch(ratesDataList: IOrderBatchRateInfo[]) {
    const sortedProviders = this.getSortedProvidersForBestMatch();
    const defaultCarrierId = this.selectedCarrierId || (sortedProviders?.length && sortedProviders[0].carrierId);
    const ratesData = ratesDataList.find((ratesData) => ratesData.carrier?.id == defaultCarrierId);
    this.serviceLevelsRates = ratesData?.totalServiceLevelsRatesData?.selectedServiceLevelsRates;
    const defaultServiceLevelData = this.serviceLevelsRates?.[0];
    if (defaultServiceLevelData) {
      const optimalProviderRates: IServiceLevelProviderChosenRates =
        this.findOptimalProviderRates(defaultServiceLevelData);
      this.selectedProvider = optimalProviderRates.provider;
      this.selectedServiceLevel = defaultServiceLevelData.serviceLevel;

      const firstProvider = sortedProviders.find((provider) => provider.carrierId == defaultCarrierId);
      const optimalProvider = sortedProviders.find(
        (provider) => provider.carrierId == defaultCarrierId && provider.name == optimalProviderRates.provider,
      );

      // if the firstProvider has more arriving on time orders it should be the optimal chosen
      const providerShouldChosenAsOptimal =
        !this.userSelectedProvider && firstProvider?.arrivingOnTime > optimalProvider?.arrivingOnTime
          ? firstProvider
          : optimalProvider;
      if (providerShouldChosenAsOptimal.name != this.selectedProvider) {
        this.onChangeBestMatchProvider(providerShouldChosenAsOptimal);
      }
    }

    this.modifySelectedCarrier(defaultCarrierId);
  }

  initOrdersAdditionalShippingData(carrierId?: number) {
    const forceSaturdayDelivery = this.data.addToBatchId && this.orderBatch.saturdayDelivery;
    this.ordersShippingAdditionalData = this.orderBatch.orders?.map((order) => ({
      orderId: order.id,
      isSaturdayDelivery: forceSaturdayDelivery || false,
      isShouldTrySuggestedAddress: false,
      isTriedSuggestedAddress: false,
    }));
    if (this.isBestMatch && carrierId) {
      this.ordersShippingAdditionalDataByCarrier.set(carrierId, this.ordersShippingAdditionalData);
    }
  }

  async retryFetchFailedRates(
    oldBatchRatesData: IOrderBatchRateInfo,
    ordersToRetry?: string[],
    ratesOptions?: RatesRequestOptions,
  ) {
    try {
      const failedOrdersIdsToRetry =
        ordersToRetry ??
        this.rows.filter((row) => row.isApiErrorResponce || row.isShouldTrySuggestedAddress)?.map((val) => val.orderId);
      if (!failedOrdersIdsToRetry?.length || !oldBatchRatesData?.totalServiceLevelsRatesData) {
        return;
      }

      const oldAllBatchRatesData = oldBatchRatesData.totalServiceLevelsRatesData;

      const ratesResponce = await this.getOrdersRates(failedOrdersIdsToRetry, {
        carrierId: this.selectedCarrierId,
        ...ratesOptions,
      });
      if (!ratesResponce) {
        return;
      }

      for (const failedOrderId of failedOrdersIdsToRetry) {
        if (ratesResponce?.rateInfo) {
          const orderBatchRateInfo: IOrderBatchRateInfo = ratesResponce.rateInfo;
          const newRates = orderBatchRateInfo?.totalServiceLevelsRatesData;
          if (!newRates) {
            return;
          }
          const newOrderRatesOptions = newRates.ordersRatesOptions.find((val) => val.orderId === failedOrderId);
          const newOrderRatesMessages = newRates.ordersRatesMessages.find((val) => val.orderId === failedOrderId);
          const newServiceLevelsRates = newRates.selectedServiceLevelsRates;

          if (!newOrderRatesOptions || !newOrderRatesMessages || !newServiceLevelsRates) {
            throw new Error(`Missing rates data for order: ${failedOrderId}`);
          }

          // Here we update order all possible rates, updated for new package size
          const allOrderRates = oldAllBatchRatesData.ordersRatesOptions.find((val) => val.orderId === failedOrderId);
          allOrderRates.rates = newOrderRatesOptions.rates;

          // Here we update service levels rates data for current row order number
          oldAllBatchRatesData.selectedServiceLevelsRates.forEach((currServiceLevelRates) => {
            const newServiceLevelRates = newServiceLevelsRates?.find((val) => {
              return val?.serviceLevel === currServiceLevelRates?.serviceLevel;
            });

            const updatedProviders: string[] = [];
            currServiceLevelRates.ratesPerProviders?.forEach((oldProviderRates) => {
              const newProviderRates =
                newServiceLevelRates?.ratesPerProviders?.find((newProviderRates) => {
                  return newProviderRates?.provider?.toLowerCase() === oldProviderRates?.provider?.toLowerCase();
                }) ?? null;
              this.updatePoviderRatesData(oldProviderRates, newProviderRates, failedOrderId);
              updatedProviders.push(oldProviderRates?.provider?.toLowerCase());
            });

            const newlyCreatedProviders = newServiceLevelRates.ratesPerProviders?.filter((newProviderRates) => {
              return !updatedProviders.includes(newProviderRates.provider?.toLowerCase());
            });
            this.addNewProvidersRatesToServiceLevel(
              currServiceLevelRates,
              newlyCreatedProviders as IServiceLevelProviderChosenRates[],
            );
          });

          // oldBatchRatesData.totalServiceLevelsRatesData.selectedServiceLevelsRates.forEach(oldServiceLevelRates => {
          //   oldServiceLevelRates
          // });

          const index = oldAllBatchRatesData.ordersRatesMessages?.findIndex((val) => val?.orderId === failedOrderId);
          if (index >= 0) {
            oldAllBatchRatesData.ordersRatesMessages[index] = newOrderRatesMessages;
          }
        } else if (ratesResponce?.rateInfoList) {
          // Best match approach - retrieving rates for all carriers together
          const orderBatchRateInfoList: IOrderBatchRateInfo[] = ratesResponce.rateInfoList;
          // TODO: add support of suggested addreses for bestMatch - version 2
        }
      }

      await this.initializeBatchRatesData(oldBatchRatesData);
      this.proccessSuggestedAddressesUsageData();
      return oldBatchRatesData;
    } catch (e) {
      console.log('Failed to retry failed rates');
    }
  }

  private ordersThatRequireRetryPolling(orderBatchRatesData: IOrderBatchRateInfo) {
    return (
      orderBatchRatesData?.totalServiceLevelsRatesData?.ordersRatesMessages
        ?.filter((message) =>
          message.warningMessages?.some(
            (warningMessage) => warningMessage.text === 'Rates retrieval failed for all carrier accounts',
          ),
        )
        .map((message) => message.orderId) ?? []
    );
  }

  async pollForRatesRetry(orderBatchRatesData: IOrderBatchRateInfo, ratesOptions?: RatesRequestOptions) {
    try {
      const shopMetadata = this._shopService.metadataSignal();
      const retryPollingEnabled = shopMetadata?.enableCarrierRatesRetry;
      const retryPollingMaxAttempts = shopMetadata?.carrierRatesRetryMaxRetries ?? 3;
      const retryPollingIntervalMs = shopMetadata?.carrierRatesRetryIntervalMs ?? 2 * TimeUnits._SECOND_IN_MS;
      const retryPollingIntervalMultiplier = shopMetadata?.carrierRatesRetryIntervalMultiplier ?? 1.5;
      let ordersToRetry = this.ordersThatRequireRetryPolling(orderBatchRatesData);
      const isDialogClosing = signal(false);
      this.dialogRef.beforeClosed().subscribe(() => {
        isDialogClosing.set(true);
      });
      if (!retryPollingEnabled || !ordersToRetry.length) {
        return;
      }
      let attempts = 0;

      while (attempts < retryPollingMaxAttempts && !isDialogClosing()) {
        console.log(
          `Polling for rates retry in ${retryPollingIntervalMs} ms, attempt ${attempts + 1}/${retryPollingMaxAttempts}...`,
        );
        await new Promise((resolve) =>
          setTimeout(resolve, retryPollingIntervalMs * Math.pow(retryPollingIntervalMultiplier, attempts)),
        );
        if (isDialogClosing()) {
          return;
        }
        const newBatchData = await this.retryFetchFailedRates(orderBatchRatesData, ordersToRetry, ratesOptions);
        ordersToRetry = this.ordersThatRequireRetryPolling(newBatchData);
        if (!ordersToRetry?.length) {
          return;
        }
        attempts++;
      }
    } catch (err) {
      console.error('Failed to poll for rates retry');
      return;
    }
  }

  initShopService() {
    return new Promise((res) => {
      this._shopService.shop$.pipe(first()).subscribe((shop) => {
        this.shopMetadata$ = of(shop?.metadata);
        const {
          metadata: {
            isSendSaturdayDeliveryInThursday,
            isSendSaturdayDeliveryInFriday,
            currency,
            forceFulfillScreenNavigate,
            ianaTimeZone,
          },
        } = shop;
        this.isThursdaySaturdayDelivery = !!isSendSaturdayDeliveryInThursday;
        this.isFridaySaturdayDelivery = !!isSendSaturdayDeliveryInFriday;
        this.shopsCurency = currency;
        this.forceFulfillScreenNavigate = !!forceFulfillScreenNavigate;
        this.shopIanaTimezone = ianaTimeZone;
        if (!this.isColumnsFiltered) {
          this.isColumnsFiltered = true;
          this.columns = this.columns.filter((f) => !f.displayCondition || f.displayCondition(shop?.metadata));
        }
        res(true);
      });
    });
  }

  getDropdownButtonClass(dropdownOpened: boolean) {
    if (this.isLoadingRates()) {
      return 'dropdown-button-disabled';
    } else if (dropdownOpened) {
      return 'dropdown-button-opened';
    } else if (!dropdownOpened) {
      return 'dropdown-button-closed';
    }
  }

  formatHoursOffsetDateString(hoursOffset: number, newMode: boolean = false) {
    const currentDate = new Date();
    currentDate.setHours(currentDate.getHours() + hoursOffset);

    const weekDayStr = currentDate.toLocaleDateString('en-US', { weekday: 'short' });
    const dateStr = currentDate.toLocaleString('en-US', {
      day: 'numeric',
      month: 'short',
    });

    let result = `${weekDayStr}, ${dateStr}`;
    if (this.showSaturdayDeliveryStr(weekDayStr)) {
      result = newMode ? result : `${result} | Saturday Delivery`;
    }
    return result;
  }

  async onDatePickerChangeSelectedHoursOffset(pickedDate: any, sendRequest: boolean = true) {
    if (!pickedDate) {
      return;
    }
    pickedDate = new Date(pickedDate);

    let hoursOffset = (pickedDate.getTime() - this.startDate.getTime()) / TimeUnits._HOUR_IN_MS;
    hoursOffset = this.normalizeHoursDifference(hoursOffset);

    if (this.selectedOffsetOption === hoursOffset) {
      return;
    }

    const oldPickedDate = this.currentDate;
    if (hoursOffset >= 0) {
      this.selectedOffsetOption = hoursOffset;
      this.currentDate = pickedDate;
      if (this.isBestMatch) {
        const carrierIds = this.cachedDataByCarriers && [...this.cachedDataByCarriers.keys()];
        for (const carrierId of carrierIds) {
          this.updateCarrierDataProperty(
            carrierId,
            CarrierCachedFieldNames.SELECTED_OFFSET_SET_OPTION,
            this.selectedOffsetOption,
          );
          this.updateCarrierDataProperty(carrierId, CarrierCachedFieldNames.CURRENT_DATE, this.currentDate);
        }
      }

      this.isShowSaturdayDeliveryOption = this.checkIfSaturdayDeliveryOption();
      if (!this.isShowSaturdayDeliveryOption) {
        this.isSaturdayDeliveryChosen = false;
        this.ordersShippingAdditionalData.forEach((orderShippingData) => {
          orderShippingData.isSaturdayDelivery = false;
        });
      }

      if (sendRequest) {
        const response = await this.regenerateOrdersRatesSettings(this.selectedOffsetOption, false);
        if (!response) {
          const revertedDate =
            (oldPickedDate.getDate() - this.startDate.getDate()) / TimeUnits._HOUR_IN_MS > TimeUnits._MS_IN_DAY
              ? oldPickedDate
              : this.startDate;
          this.onDatePickerChangeSelectedHoursOffset(moment(revertedDate), false);
          this.toastService.show(PdqToastComponent, {
            position: 'top',
            message: 'Failed to update delivery date',
            mode: 'danger',
            duration: TimeUnits._SECOND_IN_MS * 3,
          });
        }
      }
    }

    this.performInitialSort();
  }

  private normalizeHoursDifference(hoursDifference: number) {
    let normalizedDiff = hoursDifference;
    if ((normalizedDiff - 1) % 24 === 0) {
      normalizedDiff = normalizedDiff - 1;
    }
    if ((normalizedDiff + 1) % 24 === 0) {
      normalizedDiff = normalizedDiff + 1;
    }

    return normalizedDiff;
  }
  private initCarrierCached(carrier: Carrier) {
    if (!carrier) {
      console.log(`carrier is missing on initialize`);
    }
    const carrierData: CarrierCachedData = {
      name: undefined,
      type: undefined,
      currencySign: undefined,
      analyzedDataByProviders: new Map<string, AnalyzedData>(),
      isMACarrier: undefined,
      totalRatesData: [],
      currentDate: undefined,
      selectedOffsetOption: 0,
    };
    this.cachedDataByCarriers.set(carrier?.id, carrierData);
  }

  private initCarrierType(carrier?: Carrier) {
    if (!this.isBestMatch) {
      this.carrierType = this.orderBatch?.selectedCarrier?.type;
      this.isMACarrier = masterCarrierTypeNames.includes(this.carrierType.name);
      this.scheduledPickupIsSupported = this.carrierType?.custom_fields?.supportsScheduledPickup;
    } else if (this.isBestMatch && carrier) {
      this.updateCarrierDataProperty(carrier.id, CarrierCachedFieldNames.TYPE, carrier.type);
      this.updateCarrierDataProperty(carrier.id, CarrierCachedFieldNames.NAME, carrier.name);
      this.updateCarrierDataProperty(
        carrier.id,
        CarrierCachedFieldNames.IS_MA_CARRIER,
        masterCarrierTypeNames.includes(carrier.type.name),
      );
      if (this.scheduledPickupIsSupported && !carrier.type?.custom_fields?.supportsScheduledPickup) {
        this.scheduledPickupIsSupported = false;
      }
    }
  }

  private initDateAndOffset(ratesData: IOrderBatchRateInfo, carrier?: Carrier) {
    this.currentDate = new Date(Date.now());

    if (this.data?.addToBatchId) {
      const selectedDate = new Date(this.data.batch?.pickupDate);
      const hoursOffset = (selectedDate.getTime() - this.currentDate.getTime()) / TimeUnits._HOUR_IN_MS;
      this.selectedOffsetOption = this.normalizeHoursDifference(hoursOffset);
      this.currentDate = selectedDate;
      return;
    }

    const initialHoursOffset = ratesData?.totalServiceLevelsRatesData?.hoursOffset ?? 0;
    if (initialHoursOffset > 0) {
      this.currentDate.setTime(this.currentDate.getTime() + initialHoursOffset * TimeUnits._HOUR_IN_MS);
      this.selectedOffsetOption = initialHoursOffset;
    }

    if (this.isBestMatch && carrier) {
      this.updateCarrierDataProperty(carrier.id, CarrierCachedFieldNames.CURRENT_DATE, this.currentDate);
      this.updateCarrierDataProperty(
        carrier.id,
        CarrierCachedFieldNames.SELECTED_OFFSET_SET_OPTION,
        this.selectedOffsetOption,
      );
    }
  }

  private async initLatestCurrencyRates() {
    try {
      this.latestCurrencyRates = await this.currencyRatesService.getLatestCurrencyRates();
    } catch (e) {
      console.log('Failed to fetch latest currency rates');
    }
  }

  private checkIfSaturdayDeliveryOption() {
    return this.carrierType?.custom_fields?.supportsSaturdayDelivery === false
      ? false
      : this.currentDate?.getDay() === 5 || this.currentDate?.getDay() === 4;
  }

  async onChangeSaturdayDelivery(isSaturdayDelivery: boolean, sendRequest: boolean = true) {
    const allOrdersIsFittingChoise = this.rows.every((row) => row.isSaturdayDelivery === isSaturdayDelivery);
    if (this.isSaturdayDeliveryChosen === isSaturdayDelivery && allOrdersIsFittingChoise) {
      return;
    }

    this.isSaturdayDeliveryChosen = isSaturdayDelivery;
    this.ordersShippingAdditionalData.forEach((orderShippingData) => {
      const fittingRow = this.rows.find((row) => row.orderId === orderShippingData.orderId);
      // orderShippingData.isSaturdayDelivery = !!fittingRow?.isSaturdayDelivery;
      orderShippingData.isSaturdayDelivery = isSaturdayDelivery;
      fittingRow.isSaturdayDelivery = isSaturdayDelivery;
    });
    if (this.isBestMatch) {
      const carrierIds = this.cachedDataByCarriers && [...this.cachedDataByCarriers.keys()];
      for (const carrierId of carrierIds) {
        const curRows = this.rowsByCarriers.get(carrierId);
        const curOrderShippingAdditionalData = this.ordersShippingAdditionalDataByCarrier.get(carrierId);
        curOrderShippingAdditionalData.forEach((orderShippingData) => {
          const fittingRow = curRows.find((row) => row.orderId === orderShippingData.orderId);
          orderShippingData.isSaturdayDelivery = isSaturdayDelivery;
          fittingRow.isSaturdayDelivery = isSaturdayDelivery;
        });
        this.rowsByCarriers.set(carrierId, curRows);
        this.ordersShippingAdditionalDataByCarrier.set(carrierId, curOrderShippingAdditionalData);
      }
    }
    if (sendRequest) {
      let response;
      try {
        response = await this.regenerateOrdersRatesSettings(this.selectedOffsetOption);
      } catch (e) {}
      if (!response) {
        await new Promise((resolve) => setTimeout(resolve, TimeUnits._SECOND_IN_MS / 2));
        this.saturdayCheckbox?.changeCheckedFromOutside(!isSaturdayDelivery);
        this.toastService.show(PdqToastComponent, {
          position: 'top',
          message: 'Failed to update Saturday delivery',
          mode: 'danger',
          duration: TimeUnits._SECOND_IN_MS * 3,
        });
        this.onChangeSaturdayDelivery(!isSaturdayDelivery, false);
      }
    }
    this.performInitialSort();
  }

  async onChangeOrderSaturdayDelivery(event: { orderId: string; isSaturdayDelivery: boolean }) {
    // if received empty event, exit function
    if (!event?.orderId) {
      return;
    }

    const current = this.ordersShippingAdditionalData?.find((val) => val.orderId === event.orderId);
    // if received 'saturday delivery' selection is equal to current - exit function
    if (current && current.isSaturdayDelivery === event.isSaturdayDelivery) {
      return;
    }

    // update selection of order's saturday delivery
    if (current) {
      current.isSaturdayDelivery = event.isSaturdayDelivery ?? false;
    } else {
      const row = this.rows.find((val) => val.orderId === event.orderId);
      this.ordersShippingAdditionalData.push({
        orderId: event.orderId,
        isSaturdayDelivery: event.isSaturdayDelivery ?? false,
        isShouldTrySuggestedAddress: row?.isShouldTrySuggestedAddress,
        isTriedSuggestedAddress: row?.isTriedSuggestedAddress,
      });
    }

    const currentBoxId = this.currentBoxesSelections?.find((val) => val.orderId === event.orderId)?.box?.id;
    const currentRow = this.rows.find((val) => val.orderId === event.orderId);

    const response = await this.getOrdersRates([event.orderId], {
      boxId: currentBoxId,
      carrierId: this.selectedCarrierId,
    });
    if (response?.rateInfo) {
      const orderBatchRateInfo: IOrderBatchRateInfo = response.rateInfo;
      if (orderBatchRateInfo?.totalServiceLevelsRatesData) {
        const newRates = orderBatchRateInfo?.totalServiceLevelsRatesData;
        this.updateBoxRatesCacheData(newRates, currentBoxId, orderBatchRateInfo?.carrier?.id);
        this.updateNewBoxesAndRatesData([currentRow], newRates);
      }
    } else if (response?.rateInfoList) {
      // Best match approach - handle the specific order at all carriers together
      // TODO: version 2 of best match
    }

    this.rows = [...this.rows];
    if (this.isBestMatch && this.selectedCarrierId) {
      this.rowsByCarriers.set(this.selectedCarrierId, this.rows);
    }
    this.generateAnalyzedBatchData();

    this.isSaturdayDeliveryChosen = this.rows.every((row) => row.isSaturdayDelivery);
  }

  private showSaturdayDeliveryStr(weekDay: string) {
    if (
      (this.isThursdaySaturdayDelivery && weekDay === 'Thu') ||
      (this.isFridaySaturdayDelivery && weekDay === 'Fri')
    ) {
      return true;
    }

    return false;
  }

  private async regenerateOrdersRatesSettings(hoursOffset: number, ignoreInternalRates = true) {
    if (!this.isLoadingRates()) {
      // Generate array of order ids that were not detached from batch
      const ordersIds = this.rows.map((val) => val.orderId);

      const response = await this.getOrdersRates(ordersIds, { hoursOffset, ignoreInternalRates });
      const ratesOptions: RatesRequestOptions = { hoursOffset, ignoreInternalRates };
      if (response?.rateInfo) {
        const orderBatchRateInfo: IOrderBatchRateInfo = response.rateInfo;
        this.initializeOrderBatchRatesData(
          orderBatchRateInfo,
          this.orderBatch?.orders.filter((order) => ordersIds.includes(order.id)),
        );
        this.proccessEmptyStateData();
        this.initializeTabsConfigData();
        this.generateAnalyzedBatchData();
        this.proccessSuggestedAddressesUsageData();
        await this.pollForRatesRetry(orderBatchRateInfo, ratesOptions);
      }
      // Best match approach - retrieving rates for all carriers together
      else if (response?.rateInfoList) {
        const orderBatchRatesDataList = response.rateInfoList;
        for (const [i, orderBatchRatesData] of orderBatchRatesDataList.entries()) {
          const carrier = orderBatchRatesData.carrier;
          this.initializeOrderBatchRatesDataForBestMatch(
            orderBatchRatesData,
            this.orderBatch?.orders.filter((order) => ordersIds.includes(order.id)),
          );
          this.initializeTabsConfigData(carrier?.id);
        }
        this.initDefaultDataForBestMatch(orderBatchRatesDataList);
        this.proccessEmptyStateData();
        this.proccessSuggestedAddressesUsageData();
      }
      return response;
    }
  }

  private initWindowTitle(orderBatch: OrderBatch) {
    let carrierName: string = orderBatch?.selectedCarrier?.name;
    if (carrierName) {
      carrierName = carrierName.toUpperCase();
    }

    this.carrierName = carrierName;
  }

  // Whether have to use rate currency data?
  private initializeLocalizationData(ratesData: IOrderBatchRateInfo) {
    // Uses shop's currency for Master Account carriers, not from rates
    if (this.isBestMatch) {
      const carrierId = ratesData?.carrier?.id;
      const currencyCode =
        this.getCarrierDataProperty(carrierId, CarrierCachedFieldNames.IS_MA_CARRIER) && this.latestCurrencyRates.length
          ? this.shopsCurency
          : ratesData?.totalServiceLevelsRatesData?.senderCurrencyLocal;
      if (currencyCode) {
        const currencySign = getSignOfCurrency(currencyCode) ?? null;
        this.updateCarrierDataProperty(carrierId, CarrierCachedFieldNames.CUURENCY_SIGN, currencySign);
        this.currencySign = currencySign;
      }
    } else {
      const currencyCode =
        this.isMACarrier && this.latestCurrencyRates.length
          ? this.shopsCurency
          : ratesData?.totalServiceLevelsRatesData?.senderCurrencyLocal;

      if (currencyCode) {
        this.currencySign = getSignOfCurrency(currencyCode) ?? null;
      }
    }
  }

  private initializeOrderBatchRatesData(ratesData: IOrderBatchRateInfo, orders: Order[]) {
    try {
      this.allOrdersRates = [];
      this.selectedRatesDetails = [];
      this.serviceLevelsRates = [];
      this.rows = [];

      if (this.data?.addToBatchId) {
        this.userSelectedProvider = this.data.batch?.finalCarrier;
      }

      // If carrier generated rates, we proccess this data. otherwise we generate
      // fallback 'rows' array from 'orders' array, to hold only 'orderNumber' data
      if (ratesData?.generatedRatesData) {
        this.missingBatchRates = false;
        const totalRatesData = ratesData?.totalServiceLevelsRatesData;

        this.ordersMessages = totalRatesData?.ordersRatesMessages ?? [];
        this.proccessOrderBatchRatesBoxesData(totalRatesData);
        this.saveInitialRatesDataToCache(totalRatesData);
        this.proccessOrdersRatesOptions(totalRatesData);
        this.proccessOrdersSelectedServiceLevelsRates(totalRatesData, orders);
      } else {
        this.missingBatchRates = true;
        this.selectedProvider = this.orderBatch?.selectedCarrier?.name;
        this.generateFallbackRowsArray(this.orderBatch);
      }

      // --- Moved Outside ----
      // this.proccessEmptyStateData();
    } catch (e) {
      console.log('Error during initializing rates data: ', e);
      throw e;
    }
  }

  private initializeOrderBatchRatesDataForBestMatch(ratesData: IOrderBatchRateInfo, orders: Order[]) {
    try {
      const carrierId = ratesData.carrier?.id;
      this.allOrdersRatesByCarriers.set(carrierId, []);
      this.serviceLevelsRatesByCarriers.set(carrierId, []);
      this.rowsByCarriers.set(carrierId, []);

      if (ratesData?.generatedRatesData) {
        this.missingBatchRates = false;
        this.missingBatchRatesByCarriers.set(carrierId, false);
        const totalRatesData = ratesData?.totalServiceLevelsRatesData;
        this.ordersMessages = totalRatesData?.ordersRatesMessages ?? [];
        this.ordersMessagesByCarriers.set(carrierId, totalRatesData?.ordersRatesMessages ?? []);
        this.proccessOrderBatchRatesBoxesData(totalRatesData, carrierId);
        this.saveInitialRatesDataToCache(totalRatesData, { carrierId });
        this.proccessOrdersRatesOptions(totalRatesData, carrierId);
        this.proccessOrdersSelectedServiceLevelsRates(totalRatesData, orders, carrierId);
      } else {
        this.missingBatchRates = true;
        this.missingBatchRatesByCarriers.set(carrierId, true);
        this.generateFallbackRowsArray(this.orderBatch, carrierId);
      }
    } catch (e) {
      console.log('Error during initializing rates data: ', e);
      throw e;
    }
  }

  private proccessOrderBatchRatesBoxesData(totalBatchRates: IAllServiceLevelsRates, carrierId?: number) {
    this.supportMeasurements = false;
    this.commonBoxesOptions = [];

    this.initialBoxesSelections = [];
    this.lastCommonBoxesSelections = [];
    this.currentBoxesSelections = [];

    this.ordersParcelsOptions = totalBatchRates.ordersParcelsOptions ?? null;

    const allboxesOptions = totalBatchRates?.boxesOptions;
    const selectedInitialBoxes = totalBatchRates?.selectedOrdersBoxes;

    if (totalBatchRates?.multiLabelSelectedOrderBoxes) {
      this.multiLabelSelectedOrderBoxes = totalBatchRates.multiLabelSelectedOrderBoxes;
    }

    if (allboxesOptions && selectedInitialBoxes) {
      this.supportMeasurements = true;
      this.commonBoxesOptions = [...allboxesOptions];
      this.initialBoxesSelections = selectedInitialBoxes.map((val) => ({
        ...val,
      }));
      this.lastCommonBoxesSelections = selectedInitialBoxes.map((val) => ({
        ...val,
      }));
      this.currentBoxesSelections = selectedInitialBoxes.map((val) => ({
        ...val,
      }));
    } else {
      this.supportMeasurements = false;
      this.commonBoxesOptions = [];
      this.initialBoxesSelections = [];
      this.lastCommonBoxesSelections = [];
      this.currentBoxesSelections = [];
    }

    if (this.isBestMatch && carrierId) {
      this.supportMeasurementsByCarriers.set(carrierId, this.supportMeasurements);
      this.commonBoxesOptionsByCarriers.set(carrierId, this.commonBoxesOptions);
      this.initialBoxesSelectionsByCarriers.set(carrierId, this.initialBoxesSelections);
      this.lastCommonBoxesSelectionsByCarriers.set(carrierId, this.lastCommonBoxesSelections);
      this.currentBoxesSelectionsByCarriers.set(carrierId, this.currentBoxesSelections);
      this.ordersParcelsOptionsByCarriers.set(carrierId, this.ordersParcelsOptions);
      this.multiLabelSelectedOrderBoxesByCarriers.set(carrierId, this.multiLabelSelectedOrderBoxes);
    }
  }

  private proccessOrdersRatesOptions(totalBatchRates: IAllServiceLevelsRates, carrierId?: number) {
    if (totalBatchRates?.ordersRatesOptions) {
      this.allOrdersRates = totalBatchRates.ordersRatesOptions;
      this.retrieveAllSelectedRates(totalBatchRates.ordersRatesOptions);
      if (this.isBestMatch && carrierId) {
        this.allOrdersRatesByCarriers.set(carrierId, totalBatchRates.ordersRatesOptions);
      }
    } else {
      // TODO: implement
      // this.setServiceLevelColumnTypeToText();
    }
  }

  private retrieveAllSelectedRates(allOrdersRates: IAllOrderRates[]) {
    const selectedRatesDetails = allOrdersRates
      ?.map((allOrderRates) => {
        const fullRateAdjusted = allOrderRates.rates?.find(
          (rate) =>
            rate.provider == allOrderRates.selectedRate?.provider &&
            rate.carrierServiceLevelInternalToken == allOrderRates.selectedRate?.carrierServiceLevelInternalToken,
        );
        return fullRateAdjusted ? { ...fullRateAdjusted, carrierId: allOrderRates.selectedRate.carrierId } : null;
      })
      ?.filter(Boolean);
    if (selectedRatesDetails?.length) {
      this.selectedRatesDetails = this.selectedRatesDetails.concat(selectedRatesDetails);
    }
  }

  private proccessEmptyStateData() {
    if (this.rows?.length > 0) {
      // this.isEmptyStateOn = this.serviceLevelsRates?.every(serviceLevelRate => {
      //   return serviceLevelRate.ratesPerProviders?.every(providerRates => {
      //     return !providerRates.ordersRatesDetails?.length && providerRates?.ordersMissingRatesDetails?.length;
      //   });
      // });

      const allRowsMissingRates = this.rows?.every((row) => {
        return !row.serviceLevelOptions?.length && !row.currentRateObject;
      });
      const allOrdersMissingRatesOptions = this.allOrdersRates?.every((val) => !val?.rates?.length);

      this.isEmptyStateOn = allRowsMissingRates && allOrdersMissingRatesOptions;
    } else {
      this.isEmptyStateOn = true;
    }

    if (this.isEmptyStateOn) {
      // update warning messages for all orders
      this.rows?.forEach((row) => {
        this.proccessReceivedRatesMessagesData(row, this.carrierType.name !== 'Self-Pickup');
      });
    }
  }

  /**
   * Proccess and initialize all information concerning chosen rates for each of carrier's
   * supported service levels option
   * @param totalBatchRates: order batch rates data
   */
  private proccessOrdersSelectedServiceLevelsRates(
    totalBatchRates: IAllServiceLevelsRates,
    batchOrders: Order[],
    carrierId?: number,
  ) {
    if (totalBatchRates?.selectedServiceLevelsRates) {
      this.serviceLevelsRates = totalBatchRates.selectedServiceLevelsRates;
      this.sortServiceLevelsRatesDataByIndex(this.serviceLevelsRates);
      if (this.isBestMatch && carrierId) {
        this.serviceLevelsRatesByCarriers.set(carrierId, this.serviceLevelsRates);
      }

      // recently we sorted service levels optimal rates arrays by  service level indexes
      // service level with lowest index is positioned as 'default' service level
      let defaultServiceLevelData: IServiceLevelChosenRates;
      if (this.userSelectedServiceLevel) {
        defaultServiceLevelData = this.serviceLevelsRates?.find((val) =>
          isServiceLevelsEquals(val.serviceLevel, this.userSelectedServiceLevel),
        );
      } else {
        defaultServiceLevelData = this.serviceLevelsRates?.[0];
      }
      // TODO: add code that figures out selected service level;

      this.updateCurrentSelectedServiceLevelRatesData(defaultServiceLevelData, batchOrders, carrierId);
    }
  }

  private updateCurrentSelectedServiceLevelRatesData(
    serviceLevelRates: IServiceLevelChosenRates,
    batchOrders: Order[],
    carrierId?: number,
  ) {
    const optimalProviderRates: IServiceLevelProviderChosenRates = this.findOptimalProviderRates(serviceLevelRates);
    const ordersWithRatesData = optimalProviderRates?.ordersRatesDetails?.length ?? 0;
    const ordersWithoutRatesData = optimalProviderRates?.ordersMissingRatesDetails?.length ?? 0;

    if (this.isBestMatch && carrierId) {
      const otherProvidersRates = serviceLevelRates.ratesPerProviders?.filter(
        (val) => !_.isEqual(val, optimalProviderRates),
      );
      for (const otherProviderRates of otherProvidersRates) {
        this.selectedProvider = otherProviderRates.provider;
        this.selectedServiceLevel = serviceLevelRates.serviceLevel;
        this.proccessReceivedRatesData(otherProviderRates, batchOrders, carrierId);
      }
    }
    if (batchOrders?.length > 0 && batchOrders.length === ordersWithRatesData + ordersWithoutRatesData) {
      this.selectedProvider = optimalProviderRates.provider;
      this.selectedServiceLevel = serviceLevelRates.serviceLevel;
      this.proccessReceivedRatesData(optimalProviderRates, batchOrders, carrierId);
      this.generateInvalidOrdersErrorMessages(carrierId);
    }
  }

  private findOptimalProviderRates(serviceLevelRates: IServiceLevelChosenRates) {
    let optimalProviderRates: IServiceLevelProviderChosenRates;
    if (this.userSelectedProvider) {
      optimalProviderRates = serviceLevelRates.ratesPerProviders?.find(
        (val) => val?.provider === this.userSelectedProvider,
      );
    } else {
      // reverse that array becuase the last isOptimal provider have the most profit fields
      optimalProviderRates = serviceLevelRates.ratesPerProviders?.reverse().find((val) => val?.isOptimal);
    }
    return optimalProviderRates;
  }

  /**
   * When we receive data about chosen rates for carrier service levels, we have to decide
   * in which order we show those service levels to user (in form of tabs), and which service
   * level will be chosen as first (default) picked service level
   * @param rates: service levels chosen rates data
   */
  private sortServiceLevelsRatesDataByIndex(rates: IServiceLevelChosenRates[]) {
    let indexSorting = true;

    rates.sort((rateA, rateB) => {
      const indexA = rateA.serviceLevelIndex;
      const indexB = rateB.serviceLevelIndex;

      if (!isNumber(indexA) || !isNumber(indexB)) {
        indexSorting = false;
        return 0;
      }
      return indexA < indexB ? -1 : 1;
    });

    // If we missing index data for service levels, fallback to sorting
    // by service level name
    if (!indexSorting) {
      rates.sort((ratesA, ratesB) => {
        return ratesA.serviceLevel < ratesB.serviceLevel ? -1 : 1;
      });
    }
  }

  private formatEstimatedDateString(date: Date) {
    return moment(date).format('MMM DD');
  }

  private proccessReceivedRatesData(
    serviceLevelProviderChosenRates: IServiceLevelProviderChosenRates,
    orders: Order[],
    carrierId?: number,
  ) {
    try {
      if (this.isBestMatch && carrierId) {
        this.rows = [];
      }
      for (let i = 0; i < serviceLevelProviderChosenRates.ordersRatesDetails.length; i++) {
        let rateDetails = serviceLevelProviderChosenRates.ordersRatesDetails[i];

        const order = orders?.find?.((order) => {
          return order.id === rateDetails.orderId;
        });
        // A selectedRate is a rate the user has selected to be adjusted the most, so it overrides the recommended rate
        let currentSelectedRatesDetails, originalRateDetails;
        const selectedData = this.getBatchSelectedRatesForOrder(order.id, carrierId);
        if (
          selectedData &&
          selectedData.carrierServiceLevelInternalToken != rateDetails.carrierServiceLevelInternalToken
        ) {
          currentSelectedRatesDetails = selectedData;
          originalRateDetails = rateDetails;
          rateDetails = currentSelectedRatesDetails ?? rateDetails;
        }

        const { deliveryPromiseDate, rateEstimatedDate, deliveryPromiseStatusFlag, deliveryPromiseStatusString } =
          this.fetchShipmentDeliveryPredictionStatusData(order, rateDetails);

        const shippingFee = this.fetchShipmentShippingFee(order);

        const { boxesOptions, currentBoxSelection } = this.fetchShipmentBoxesData(
          order?.id,
          serviceLevelProviderChosenRates,
        );

        const serviceLevelOptions = this.generateDropDownOptionsArrayForServiceLevelSelection(
          rateDetails.orderId,
          serviceLevelProviderChosenRates.provider,
        );

        const convertedRatePrice = this.getCurrencyConvertedPrice(rateDetails.price, rateDetails.currency);
        const nonRecommendedServiceLevel =
          !currentSelectedRatesDetails &&
          this.getNonRecommendedServiceLevel(
            order.recommendedServiceLevelNames,
            rateDetails.carrierServiceLevelInternalToken,
            rateDetails.carrierServiceLevelName,
          );
        const row: ProccessedSingleOrderRate = {
          orderId: order?.id,
          orderNumber: this.addSplitIndexToOrderNumber(order),
          orderIsPickup: isNumber(order?.pickUpLocationId) ? true : false,
          orderShipmentFee: isNumber(shippingFee) ? `${this.currencySign}${shippingFee.toFixed(2)}` : null,
          orderPromiseDeliveryDate: deliveryPromiseDate,
          ratePrice: `${this.currencySign}${convertedRatePrice}`,
          estimationRateDeliveryDate: rateEstimatedDate ?? null,
          estimationRateDeliveryDateStr: rateEstimatedDate ? this.formatEstimatedDateString(rateEstimatedDate) : null,
          deliveryTimePredictionStatus: deliveryPromiseStatusFlag ?? null,
          deliveryTimePredictionStatusPrint: deliveryPromiseStatusString ?? null,
          etaFromPickupPrint: this.generateETAFromPickupText(rateDetails?.deliveryDateEstimationInfo),
          serviceLevelName: rateDetails.carrierServiceLevelName,
          nonRecommendedServiceLevel,
          isRecommendedServiceLevelExist: nonRecommendedServiceLevel
            ? this.getIsRecommendedServiceLevelExist(order.recommendedServiceLevelNames)
            : null,
          switchedToSelectedRate: currentSelectedRatesDetails?.carrierServiceLevelName,
          originalRecommendedRate: originalRateDetails?.carrierServiceLevelName,
          serviceLevelId: rateDetails.carrierServiceLevelId,
          serviceLevelOptions: serviceLevelOptions ?? [],
          sizeOptions: boxesOptions,
          boxName: currentBoxSelection?.name ?? null,
          boxId: currentBoxSelection?.id ?? null,
          boxSize: this.generateBoxMeasuresString(currentBoxSelection) ?? null,
          isDisabledForPurchasing: false,
          errors: rateDetails.errors || [],
          isLoadingRateData: false,
          isSaturdayDelivery:
            this.ordersShippingAdditionalData?.find((val) => val.orderId === order?.id)?.isSaturdayDelivery ?? false,
          isShowSaturdayDeliveryCheckbox: this.isShowSaturdayDeliveryOption,
          isInternalRateCardPrice: rateDetails?.isInternalRateCardPrice,
          isMergedOrder: order?.merged,
          skus: order?.skus,
          itemCount: order?.itemCount,
          products: order?.products,
          id: order?.id,
          province: order?.shippingAddress?.province,
          recommendedServiceLevelNames: order?.recommendedServiceLevelNames,
          recommendedServiceLevelNamesForDisplay: this.getRecommendedServiceLevelNamesForDisplay(
            order?.recommendedServiceLevelNames,
          ),
        };

        this.proccessReceivedRatesMessagesData(row);

        const orderShippingAdditionalData = this.ordersShippingAdditionalData?.find(
          (val) => val.orderId === row.orderId,
        );
        if (orderShippingAdditionalData) {
          orderShippingAdditionalData.isShouldTrySuggestedAddress = !!row.isShouldTrySuggestedAddress;
          orderShippingAdditionalData.isTriedSuggestedAddress = !!row.isTriedSuggestedAddress;
        } else {
          this.ordersShippingAdditionalData.push({
            orderId: row.orderId,
            isShouldTrySuggestedAddress: !!row.isShouldTrySuggestedAddress,
            isTriedSuggestedAddress: !!row.isTriedSuggestedAddress,
            isSaturdayDelivery: false,
          });
        }

        this.rows.push(row);
      }

      for (let i = 0; i < serviceLevelProviderChosenRates.ordersMissingRatesDetails?.length; i++) {
        const currOrderId = serviceLevelProviderChosenRates.ordersMissingRatesDetails[i].orderId;
        const order = orders?.find?.((order) => order?.id === currOrderId);
        const missingRateDetails = serviceLevelProviderChosenRates.ordersMissingRatesDetails[i];

        const { deliveryPromiseDate, rateEstimatedDate, deliveryPromiseStatusFlag, deliveryPromiseStatusString } =
          this.fetchShipmentDeliveryPredictionStatusData(order);

        const shippingFee = this.fetchShipmentShippingFee(order);

        const { boxesOptions, currentBoxSelection } = this.fetchShipmentBoxesData(
          order?.id,
          serviceLevelProviderChosenRates,
        );

        const row: ProccessedSingleOrderRate = {
          orderId: order?.id,
          orderNumber: this.addSplitIndexToOrderNumber(order),
          orderIsPickup: isNumber(order?.pickUpLocationId) ? true : false,
          orderShipmentFee: isNumber(shippingFee) ? `${this.currencySign}${shippingFee.toFixed(2)}` : null,
          orderPromiseDeliveryDate: deliveryPromiseDate,
          deliveryTimePredictionStatus: deliveryPromiseStatusFlag ?? null,
          deliveryTimePredictionStatusPrint: deliveryPromiseStatusString ?? null,
          serviceLevelId: null,
          sizeOptions: boxesOptions,
          isShowMissingRatesIcon: true,
          boxName: currentBoxSelection?.name ?? null,
          boxId: currentBoxSelection?.id ?? null,
          boxSize: this.generateBoxMeasuresString(currentBoxSelection) ?? null,
          isDisabledForPurchasing: true,
          errors: missingRateDetails.errors || [],
          isLoadingRateData: false,
          isSaturdayDelivery:
            this.ordersShippingAdditionalData?.find((val) => val.orderId === order?.id)?.isSaturdayDelivery ?? false,
          isShowSaturdayDeliveryCheckbox: this.isShowSaturdayDeliveryOption,
          isMergedOrder: order?.merged,
          skus: order?.skus,
          itemCount: order?.itemCount,
          products: order?.products,
          id: order?.id,
          province: order?.shippingAddress?.province,
        };

        this.proccessReceivedRatesMessagesData(row, true);
        const orderShippingAdditionalData = this.ordersShippingAdditionalData?.find(
          (val) => val.orderId === row.orderId,
        );
        if (orderShippingAdditionalData) {
          orderShippingAdditionalData.isShouldTrySuggestedAddress = !!row.isShouldTrySuggestedAddress;
          orderShippingAdditionalData.isTriedSuggestedAddress = !!row.isTriedSuggestedAddress;
        } else {
          this.ordersShippingAdditionalData.push({
            orderId: row.orderId,
            isShouldTrySuggestedAddress: !!row.isShouldTrySuggestedAddress,
            isTriedSuggestedAddress: !!row.isTriedSuggestedAddress,
            isSaturdayDelivery: false,
          });
        }
        this.rows.push(row);
      }
      if (this.isBestMatch && carrierId) {
        this.rowsByCarriers.set(carrierId, [...this.rows]);
        this.generateAnalyzedBatchData(carrierId, serviceLevelProviderChosenRates.provider);
      }
    } catch (e) {
      console.log('Error while creating proccessed rates data: ', e);
      throw e;
    }
  }

  private getOrderCurrentShippingAddress(orderId: string, isUsedSuggestedAddress?: boolean) {
    try {
      const fittingOrder = this.orderBatch.orders?.find((order) => order?.id === orderId);
      if (isUsedSuggestedAddress) {
        return fittingOrder?.suggestedShippingAddress;
      } else {
        return fittingOrder?.shippingAddress;
      }
    } catch (e) {
      console.log('Failed to fetch current shipping address');
    }
  }

  private proccessReceivedRatesMessagesData(row: ProccessedSingleOrderRate, isMissingRates?: boolean) {
    const currOrderMessages = this.ordersMessages?.find((val) => val.orderId === row?.orderId);
    row.isShowMissingRatesIcon = isMissingRates;

    if (currOrderMessages?.errorMessages) {
      row.errorMessages = currOrderMessages.errorMessages;
      row.errors = currOrderMessages.errorMessages
        .filter((error) => error.code === ShipmentCreationErrorCode.IS_DISABLED_FOR_PURCHASE)
        .map((error) => error.text);
    }

    if (currOrderMessages?.warningMessages) {
      row.isApiErrorResponce = !!currOrderMessages.warningMessages.find(
        (val) => val.code === ShipmentCreationErrorCode.PROVIDER_API_TIMEOUT,
      );
      row.isShouldTrySuggestedAddress = !!currOrderMessages.warningMessages.find(
        (val) => val.code === ShipmentCreationErrorCode.USAGE_OF_SUGGESTED_ADDRESS_REQUIRED,
      );
      row.isTriedSuggestedAddress = !!currOrderMessages.warningMessages.find(
        (val) => val.code === ShipmentCreationErrorCode.USED_SUGGESTED_ADDRESS,
      );

      row.warningMessages = currOrderMessages.warningMessages.filter(
        (val) =>
          !this.messageCodesToHide.includes(val.code) &&
          (this.isEmptyStateOn || !val?.source || val.source === this.selectedProvider?.toLowerCase()),
      );
      // row.isApiErrorResponce = !!row.warningMessages.find(
      //   (val) => val?.code === ShipmentCreationErrorCode.PROVIDER_API_TIMEOUT,
      // );
    }

    row.currentShippingAddress = this.getOrderCurrentShippingAddress(row.orderId, row.isTriedSuggestedAddress);
  }

  private fetchShipmentDeliveryPredictionStatusData(order: Order, rateDetails?: IOrderRateDetails) {
    let deliveryPromise: Date | null;
    const unproccessedPromise = order?.deliveryDate ? new Date(order.deliveryDate) : null;
    if (unproccessedPromise && unproccessedPromise?.getTime?.() > 0) {
      if (this.shopIanaTimezone) {
        try {
          const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: this.shopIanaTimezone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
          });
          deliveryPromise = new Date(formatter.format(new Date(unproccessedPromise.toUTCString())));
        } catch (e) {
          console.log('Failed to generate timezone data');
          deliveryPromise = unproccessedPromise;
        }
      } else {
        deliveryPromise = unproccessedPromise;
      }
    } else {
      deliveryPromise = null;
    }

    let estimatedDate: Date | null = null;
    const estimatedDateRawString = rateDetails?.deliveryDateEstimationInfo?.estimatedDeliveryDateRange?.max;
    if (estimatedDateRawString) {
      estimatedDate = this.generateValidDateObject(estimatedDateRawString);
    }

    const { status, print } = this.generateDeliveryPredictionStatusData(deliveryPromise, estimatedDate);

    return {
      deliveryPromiseDate: deliveryPromise,
      rateEstimatedDate: estimatedDate,
      deliveryPromiseStatusFlag: status,
      deliveryPromiseStatusString: print,
    };
  }

  private fetchShipmentShippingFee(order: Order) {
    return +order?.deliveryMethodPrice;
  }

  private fetchShipmentBoxesData(orderId: string, serviceLevelProviderRatesData?: IServiceLevelProviderChosenRates) {
    let currentBoxSelection: IBoxSizeData | null = null;
    let boxesOptions: IBoxSizeData[] | null = null;
    let boxesProccessedOptions: DropdownOption[] | null = null;

    if (this.supportMeasurements) {
      currentBoxSelection = orderId ? this.currentBoxesSelections.find((val) => val.orderId === orderId)?.box : null;

      boxesOptions = [...this.commonBoxesOptions];
      if (serviceLevelProviderRatesData?.providerSpecificBoxes) {
        boxesOptions = boxesOptions.concat(serviceLevelProviderRatesData.providerSpecificBoxes);
      }
      if (currentBoxSelection && boxesOptions.every((box) => box.id !== currentBoxSelection.id)) {
        boxesOptions.push(currentBoxSelection);
      }
      boxesProccessedOptions = this.generateDropDownOptionsArrayForBoxesSelection(boxesOptions, orderId);
    }

    return {
      boxesOptions: boxesProccessedOptions,
      currentBoxSelection: currentBoxSelection,
    };
  }

  private generateDropDownOptionsArrayForBoxesSelection(
    boxesOptions: IBoxSizeData[] | null,
    orderId: string | null,
  ): DropdownOption[] | null {
    if (!boxesOptions) {
      return null;
    }

    const res: DropdownOption[] = [];
    boxesOptions.forEach((box) => {
      let boxOptionText = `${box.name} | ${this.generateBoxMeasuresString(box)}`;

      const orderParcel = this.ordersParcelsOptions
        ?.find((val) => orderId && val?.orderId === orderId)
        ?.parcelsOptions?.find((parcel) => parcel?.id === box?.id);
      if (orderParcel?.weight && orderParcel?.weightUnit) {
        boxOptionText = `${boxOptionText} | ${orderParcel.weight}${orderParcel.weightUnit}`;
      }

      res.push({
        value: box.id,
        mainText: boxOptionText,
        secondaryText: this.generateBoxMeasuresString(box),
      });
    });

    return res;
  }

  private generateBoxMeasuresString(box: IBoxSizeData) {
    if (!box) {
      return '';
    }

    return `${box.length}x${box.width}x${box.height}${box.distanceUnit}`;
  }

  /**
   * If current carrier does not suppot orders rates generation, we have to generate default
   * rates array from information that we can retreive from order batch object (like - order number).
   * Obviously this data will be truncated, and hold no information about rates themselves.
   * @param orderBatch: order batch object
   */
  private generateFallbackRowsArray(orderBatch: OrderBatch, carrierId?: number) {
    if (this.isBestMatch && carrierId) {
      this.rows = [];
    }
    orderBatch?.orders?.forEach((order) => {
      // let deliveryPromise: Date | null;
      // let unproccessedPromise = order.deliveryDate ? new Date(order.deliveryDate) : null;
      // if (unproccessedPromise && unproccessedPromise?.getTime?.() > 0) {
      //   deliveryPromise = unproccessedPromise;
      // } else {
      //   deliveryPromise = null;
      // }

      const { deliveryPromiseDate, rateEstimatedDate, deliveryPromiseStatusFlag, deliveryPromiseStatusString } =
        this.fetchShipmentDeliveryPredictionStatusData(order);

      this.rows.push({
        orderId: order?.id,
        orderNumber: this.addSplitIndexToOrderNumber(order),
        orderIsPickup: isNumber(order?.pickUpLocationId) ? true : false,
        deliveryTimePredictionStatusPrint: DeliveryTimeStatus.UNKNOWN,
        deliveryTimePredictionStatus: DeliveryTimeStatus.UNKNOWN,
        serviceLevelName: DEFAULT_SERVICE_LEVEL_NAME,
        serviceLevelId: null,
        orderPromiseDeliveryDate: deliveryPromiseDate,
        isDisabledForPurchasing: false,
        isLoadingRateData: false,
        skus: order?.skus,
        itemCount: order?.itemCount,
        products: order?.products,
        id: order?.id,
        province: order?.shippingAddress?.province,
      });
    });
    if (this.isBestMatch && carrierId) {
      this.rowsByCarriers.set(carrierId, [...this.rows]);
    }
  }

  /**
   * In this function we analyze and store data that we can fetch only by looking at
   * order batch object, and not on each order separately
   * @param batch: order batch object
   */
  private initializeBasicBatchData() {
    this.itemsNumber = 0;
    this.chargedShippingCost = 0;
    const orders = this.orderBatch.orders?.filter((order) => !this.deletedOrdersIds.includes(order?.id));
    this.ordersCount = orders?.length ?? 0;
    this.packagesCount = this.orderBatch.numberOfPackages ?? 0;

    if (this.ordersCount) {
      for (let i = 0; i < orders.length; i++) {
        const order = orders[i];

        if (order) {
          this.itemsNumber += order.itemCount ?? 0;

          if (isNumber(this.chargedShippingCost) && isNumber(+order.deliveryMethodPrice)) {
            this.chargedShippingCost += +order.deliveryMethodPrice;
          } else {
            this.chargedShippingCost = null;
          }
        }
      }
    }
  }

  private initializeTabsConfigData(carrierId?: number) {
    this.tabsConfigData = [];

    let serviceLevelsRates;
    if (this.isBestMatch && carrierId) {
      serviceLevelsRates = this.serviceLevelsRatesByCarriers.get(carrierId);
    } else {
      serviceLevelsRates = this.serviceLevelsRates;
    }

    if (!(serviceLevelsRates?.length > 0)) {
      this.tabsConfigData.push({
        value: DEFAULT_SERVICE_LEVEL_NAME,
        label: DEFAULT_SERVICE_LEVEL_NAME,
        active: true,
      });
    }

    serviceLevelsRates.forEach((val) =>
      this.tabsConfigData.push({
        value: val.serviceLevel,
        active: isServiceLevelsEquals(val.serviceLevel, this.selectedServiceLevel) ? true : false,
        label: ServiceLevelDisplayNames[val.serviceLevel] || val.serviceLevel,
      }),
    );
    if (this.isBestMatch && carrierId) {
      this.tabsConfigDataByCarrier.set(carrierId, [...this.tabsConfigData]);
    }
  }

  private getCurrencyConvertedPrice(price, fromCurrency) {
    // convert only for Master Account carriers
    return this.isMACarrier
      ? this.currencyRatesService.getConvertedPrice(price, fromCurrency, this.shopsCurency, this.latestCurrencyRates)
      : price;
  }

  private generateDropDownOptionsArrayForServiceLevelSelection(orderId: string, provider: string): DropdownOption[] {
    return this.allOrdersRates
      ?.find((val) => {
        return val.orderId === orderId;
      })
      ?.rates?.filter((val) => {
        return val.provider === provider;
      })
      ?.sort((valA, valB) => {
        return valA.price - valB.price;
      })
      ?.map((val, index) => {
        const etaFromPickup = this.generateETAFromPickupText(val?.deliveryDateEstimationInfo);
        let mainText = val.carrierServiceLevelName?.includes(provider) ? '' : `${provider} `;
        const convertedPrice = this.getCurrencyConvertedPrice(val?.price, val?.currency);
        const priceText = convertedPrice ? `${this.currencySign}${convertedPrice}` : 'missing price data';
        mainText += `${val.carrierServiceLevelName} | ${priceText} | ${etaFromPickup || ''}`;
        return {
          mainText,
          provider: val.provider,
          value: index,
          token: val.carrierServiceLevelInternalToken,
          name: val.carrierServiceLevelName,
        };
      });
  }

  // TODO: move that function to outer component that will display info line
  private generateAnalyzedBatchData(carrierId?: number, providerName?: string) {
    let ordersArrivingOnTimeCount: number = 0;
    let ordersDeliveryPromiseUnknownCount: number = 0;
    let ordersLateCount: number = 0;
    let totalShipmentCost: number | null = 0;
    let shippingRevenue: number | null = 0;

    for (let i = 0; i < this.rows.length; i++) {
      const row = this.rows[i];
      if (row.deliveryTimePredictionStatus === DeliveryTimeStatus.INTIME) {
        ordersArrivingOnTimeCount += 1;
      }
      if (row.deliveryTimePredictionStatus === DeliveryTimeStatus.UNKNOWN) {
        ordersDeliveryPromiseUnknownCount += 1;
      }
      if (row.deliveryTimePredictionStatus === DeliveryTimeStatus.LATE) {
        ordersLateCount += 1;
      }

      if (row.ratePrice && isNumber(totalShipmentCost)) {
        // TODO: change this function to fetch valid rate price data, without removing order price sign from string
        totalShipmentCost += +row.ratePrice.slice(1);
      } else if (!isNumber(totalShipmentCost)) {
        totalShipmentCost = null;
      }
    }

    this.ordersArrivingOnTimeCount = ordersArrivingOnTimeCount;
    this.ordersUnknownDeliveryPromiseCount = ordersDeliveryPromiseUnknownCount;
    this.ordersLateCount = ordersLateCount;
    this.batchTotalShipmentCost = totalShipmentCost ? `${this.currencySign}${totalShipmentCost.toFixed(2)}` : null;
    this.batchDeliveryPromiseStatus = this.generateBatchDeliveryPromiseStatus(
      ordersArrivingOnTimeCount,
      ordersLateCount,
    );

    shippingRevenue =
      isNumber(this.chargedShippingCost) && isNumber(totalShipmentCost)
        ? this.chargedShippingCost - totalShipmentCost
        : null;

    const arrivingOnTimeStr = isNumber(this.ordersCount) ? `${ordersArrivingOnTimeCount}/${this.ordersCount}` : null;

    let totalWeight = 0;
    const weightUnit = this.currentBoxesSelections?.[0]?.box?.weightUnit || '';
    let invalidWeight = false;
    this.currentBoxesSelections?.forEach((selection) => {
      const weight = +selection?.box?.weight;
      if (!isNumber(weight)) {
        invalidWeight = true;
      } else {
        totalWeight += weight;
        totalWeight = +totalWeight.toFixed(2);
      }
    });

    this.totalRatesData = [
      {
        value: this.ordersCount ?? NOT_AVAILABLE,
        text: 'orders',
      },
      {
        value: this.itemsNumber ?? NOT_AVAILABLE,
        text: 'items',
      },
      {
        value: this.packagesCount ?? NOT_AVAILABLE,
        text: 'packages',
      },
      {
        value: invalidWeight ? NOT_AVAILABLE : `${totalWeight}${weightUnit}`,
        text: 'total weight',
      },
      // {
      //   value:
      //     isNumber(shippingRevenue) && !this.missingBatchRates
      //       ? `${this.currencySign}${shippingRevenue.toFixed(2)}`
      //       : NOT_AVAILABLE,
      //   text: 'Shipping revenue',
      // },
      // {
      //   value: moment().format('MMM DD') ?? NOT_AVAILABLE,
      //   text: 'Latest pickup day',
      // },
      // {
      //   value: arrivingOnTimeStr && !this.missingBatchRates ? arrivingOnTimeStr : NOT_AVAILABLE,
      //   text: 'Arriving on time',
      // },
      // {
      //   value:
      //     isNumber(totalShipmentCost) && !this.missingBatchRates
      //       ? `${this.currencySign}${totalShipmentCost.toFixed(2)}`
      //       : NOT_AVAILABLE,
      //   text: 'Total shipment cost',
      // },
    ];
    if (this.isBestMatch && carrierId) {
      const currentanalyzedData: AnalyzedData = {
        ordersArrivingOnTimeCount: this.ordersArrivingOnTimeCount,
        ordersUnknownDeliveryPromiseCount: this.ordersUnknownDeliveryPromiseCount,
        ordersLateCount: this.ordersLateCount,
        batchTotalShipmentCost: this.batchTotalShipmentCost,
        batchDeliveryPromiseStatus: this.batchDeliveryPromiseStatus,
      };
      if (providerName) {
        const analyzedData = this.getCarrierDataProperty(carrierId, CarrierCachedFieldNames.ANALYZED_DATA_BY_PROVIDERS);
        analyzedData.set(providerName, currentanalyzedData);
        this.updateCarrierDataProperty(carrierId, CarrierCachedFieldNames.ANALYZED_DATA_BY_PROVIDERS, analyzedData);
      } else {
        this.updateCarrierDataProperty(
          carrierId,
          CarrierCachedFieldNames.NON_PROVIDERS_ANALYZED_DATA,
          currentanalyzedData,
        );
      }
      this.updateCarrierDataProperty(carrierId, CarrierCachedFieldNames.TOTAL_RATED_DATA, this.totalRatesData);
    }
  }

  private generateBatchDeliveryPromiseStatus(ordersArriveOntimeCount: number, ordersLateCount: number) {
    const allOrdersCount = this.rows?.length;

    if (ordersArriveOntimeCount === allOrdersCount) {
      return BatchDeliveryPromiseStatus.ONTIME;
    } else if (ordersLateCount === allOrdersCount) {
      return BatchDeliveryPromiseStatus.LATE;
    } else if (ordersArriveOntimeCount > 0 || ordersLateCount > 0) {
      return BatchDeliveryPromiseStatus.MIXED;
    } else {
      return BatchDeliveryPromiseStatus.UNKNOWN;
    }
  }

  getBatchPromiseInfoText() {
    try {
      const allOrderNum = this.rows?.length;
      const ontimeOrdersNum = this.ordersArrivingOnTimeCount;
      const unknownPromiseOrdersNum = this.ordersUnknownDeliveryPromiseCount;
      const ordersLateNum = this.ordersLateCount;
      const orderNumText = allOrderNum === 1 ? 'The order' : `All ${allOrderNum} orders`;
      const verb = allOrderNum === 1 ? 'is' : 'are;';
      if (this.batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.ONTIME) {
        return this.batchTotalShipmentCost
          ? `${orderNumText} in this batch ${verb} set to arrive on time for ${this.batchTotalShipmentCost}`
          : `${orderNumText} in this batch ${verb} set to arrive on time`;
      } else if (this.batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.LATE) {
        return this.batchTotalShipmentCost
          ? `Heads up: it's ${
              this.batchTotalShipmentCost
            }, but ${orderNumText.toLowerCase()} in this batch will arrive late`
          : `Heads up: ${orderNumText.toLowerCase()} in this batch will arrive late`;
      } else if (this.batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.MIXED) {
        if (unknownPromiseOrdersNum > 0) {
          if (ontimeOrdersNum > 0 && ordersLateNum === 0) {
            return this.batchTotalShipmentCost
              ? `${this.batchTotalShipmentCost} for this batch’s ${allOrderNum} orders. ${ontimeOrdersNum} scheduled to arrive on time. ${unknownPromiseOrdersNum} with unknown delivery promise.`
              : `${ontimeOrdersNum} scheduled to arrive on time. ${unknownPromiseOrdersNum} with unknown delivery promise.`;
          } else if (ordersLateNum > 0 && ontimeOrdersNum === 0) {
            return this.batchTotalShipmentCost
              ? `${this.batchTotalShipmentCost} for this batch’s ${allOrderNum} orders. However, ${ordersLateNum} set to arrive late, and ${unknownPromiseOrdersNum} with unknown delivery promise.`
              : `${ordersLateNum} set to arrive late, and ${unknownPromiseOrdersNum} with unknown delivery promise.`;
          } else if (ordersLateNum > 0 && ontimeOrdersNum > 0) {
            return this.batchTotalShipmentCost
              ? `${this.batchTotalShipmentCost} for this batch’s ${allOrderNum} orders. ${ontimeOrdersNum} scheduled to arrive on time, ${ordersLateNum} set to arrive late, and ${unknownPromiseOrdersNum} with unknown delivery promise.`
              : `${ontimeOrdersNum} scheduled to arrive on time, ${ordersLateNum} set to arrive late, and ${unknownPromiseOrdersNum} with unknown delivery promise.`;
          }
        } else {
          return this.batchTotalShipmentCost
            ? `Hmmm... This batch's delivery is ${this.batchTotalShipmentCost}, but only ${ontimeOrdersNum} of ${allOrderNum} orders will arrive on time`
            : `Hmmm... Only ${ontimeOrdersNum} of ${allOrderNum} orders will arrive on time`;
        }
      } else if (this.batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.UNKNOWN) {
        return this.batchTotalShipmentCost
          ? `${this.batchTotalShipmentCost} for this batch’s ${allOrderNum} orders, but with unknown delivery promise, on-time delivery can’t be confirmed.`
          : `${allOrderNum} orders, but with unknown delivery promise, on-time delivery can’t be confirmed.`;
      }
    } catch (e) {
      console.log(`Error: ${JSON.stringify(e)}`);
    }
  }

  getBatchPromiseInfoIconName() {
    if (this.batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.ONTIME) {
      return 'info-message-thumb-up.svg';
    } else if (this.batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.MIXED) {
      return 'info-message-thumb-down.svg';
    } else if (
      this.batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.LATE ||
      this.batchDeliveryPromiseStatus === BatchDeliveryPromiseStatus.UNKNOWN
    ) {
      return 'info-message-warn.svg';
    }
  }

  // Callback fired when we update service level
  async onChangeTabSelection(selectedServiceLevel: string) {
    this.recommendedCheapestQuickestLog = selectedServiceLevel; //temp , log to backend
    const serviceLevelRatesData = this.serviceLevelsRates.find((ratesData) => {
      return isServiceLevelsEquals(ratesData.serviceLevel, selectedServiceLevel);
    });
    if (!serviceLevelRatesData) {
      return;
    }

    const serviceLevelOptimalProviderRates = serviceLevelRatesData.ratesPerProviders?.find((val) => val?.isOptimal);
    if (!serviceLevelOptimalProviderRates) {
      return;
    }

    this.userSelectedServiceLevel = selectedServiceLevel;
    this.userSelectedProvider = this.data?.addToBatchId
      ? this.data?.batch?.finalCarrier
      : serviceLevelOptimalProviderRates.provider;

    // If service level selection passed all checks, then update SL and provider selections data
    this.selectedServiceLevel = selectedServiceLevel;
    this.selectedProvider = serviceLevelOptimalProviderRates.provider;
    await this.resetProviderSpecificBoxesData(serviceLevelOptimalProviderRates);

    this.updateRatesDataForAllOrders(serviceLevelOptimalProviderRates, selectedServiceLevel);
    this.generateInvalidOrdersErrorMessages();
    this.performInitialSort();
    this.rows = [...this.rows];
    this.generateAnalyzedBatchData();
    this.proccessEmptyStateData();
  }

  // Calback fired when we update service level final carrier
  async onChangeServiceLevelFinalProviderSelection(finalProvider: string) {
    if (!finalProvider) {
      return;
    }

    const serviceLevelRatesData = this.serviceLevelsRates.find((ratesData) => {
      return isServiceLevelsEquals(ratesData.serviceLevel, this.selectedServiceLevel);
    });
    if (!serviceLevelRatesData) {
      return;
    }

    const serviceLevelSelectedProviderRates = serviceLevelRatesData.ratesPerProviders?.find(
      (val) => val?.provider === finalProvider,
    );
    if (!serviceLevelSelectedProviderRates) {
      return;
    }

    this.userSelectedProvider = finalProvider;
    this.selectedProvider = finalProvider;
    await this.resetProviderSpecificBoxesData(serviceLevelSelectedProviderRates, true);
    this.updateRatesDataForAllOrders(serviceLevelSelectedProviderRates, this.selectedServiceLevel);
    this.generateInvalidOrdersErrorMessages();
    this.performInitialSort();
    this.rows = [...this.rows];
    this.generateAnalyzedBatchData();
  }

  async onChangeBestMatchProvider(providerObject: MatMenuListItem) {
    if (!providerObject) {
      return;
    }
    this.userSelectedProvider = providerObject.name;
    this.selectedProvider = providerObject.name;

    if (providerObject.carrierId != this.selectedCarrierId) {
      this.modifySelectedCarrier(providerObject.carrierId);
    }
    if (
      this.selectedServiceLevel?.toLowerCase() == DEFAULT_SERVICE_LEVEL_NAME.toLowerCase() &&
      this.serviceLevelsRates?.length > 1
    ) {
      this.selectedServiceLevel = this.serviceLevelsRates[0].serviceLevel;
    } else if (
      this.serviceLevelsRates?.length == 1 &&
      this.selectedServiceLevel?.toLowerCase() != DEFAULT_SERVICE_LEVEL_NAME.toLowerCase()
    ) {
      this.selectedServiceLevel = this.serviceLevelsRates[0].serviceLevel;
    }

    await this.onChangeServiceLevelFinalProviderSelection(providerObject.name);
  }

  async modifySelectedCarrier(carrierId: number) {
    if (!carrierId) {
      return;
    }
    if (!this.cachedDataByCarriers.has(carrierId)) {
      //TODO: - to do something here
      return;
    }
    this.selectedCarrierId = carrierId;
    const carrierData = this.cachedDataByCarriers.get(carrierId);
    this.carrierType = carrierData.type;
    this.currencySign = carrierData.currencySign;
    this.isMACarrier = carrierData.isMACarrier;
    const analyzedProviderdata = carrierData.analyzedDataByProviders.get(this.selectedProvider);
    if (this.selectedProvider) {
      this.currentDate = carrierData.currentDate;
      this.selectedOffsetOption = carrierData.selectedOffsetOption;
      this.ordersArrivingOnTimeCount = analyzedProviderdata?.ordersArrivingOnTimeCount;
      this.ordersUnknownDeliveryPromiseCount = analyzedProviderdata?.ordersUnknownDeliveryPromiseCount;
      this.ordersLateCount = analyzedProviderdata?.ordersLateCount;
      this.batchTotalShipmentCost = analyzedProviderdata?.batchTotalShipmentCost;
      this.batchDeliveryPromiseStatus = analyzedProviderdata?.batchDeliveryPromiseStatus;
    }
    this.totalRatesData = carrierData.totalRatesData;
    this.serviceLevelsRates = this.serviceLevelsRatesByCarriers.get(carrierId);
    this.allOrdersRates = this.allOrdersRatesByCarriers.get(carrierId);
    this.invalidOrdersRatesErrorMessages = this.invalidOrdersRatesErrorMessagesByCarrier.get(carrierId);
    this.processedErrorMessagesTexts = this.generateProcessedErrorMessagesTexts(this.invalidOrdersRatesErrorMessages);
    this.multiLabelSelectedOrderBoxes = this.multiLabelSelectedOrderBoxesByCarriers.get(carrierId);
    this.ordersMessages = this.ordersMessagesByCarriers.get(carrierId);
    this.boxesRatesCache = this.boxesRatesCacheByCarriers.get(carrierId);
    this.rows = this.rowsByCarriers.get(carrierId);
    this.missingBatchRates = this.missingBatchRatesByCarriers.get(carrierId);

    this.supportMeasurements = this.supportMeasurementsByCarriers.get(carrierId);
    this.commonBoxesOptions = this.commonBoxesOptionsByCarriers.get(carrierId);
    this.initialBoxesSelections = this.initialBoxesSelectionsByCarriers.get(carrierId);
    this.lastCommonBoxesSelections = this.lastCommonBoxesSelectionsByCarriers.get(carrierId);
    this.currentBoxesSelections = this.currentBoxesSelectionsByCarriers.get(carrierId);
    this.ordersParcelsOptions = this.ordersParcelsOptionsByCarriers.get(carrierId);
    this.ordersShippingAdditionalData = this.ordersShippingAdditionalDataByCarrier.get(carrierId);
    this.tabsConfigData = this.tabsConfigDataByCarrier.get(carrierId);

    // if missing data, makes it looks like empty state
    this.isEmptyStateOn = !this.serviceLevelsRates?.length || !analyzedProviderdata;
  }

  private generateProcessedErrorMessagesTexts(
    errorsMessagesData: { text: string; orderId: string; orderNumber: string; type: 'api' | 'default' }[],
  ): { ordersMissingRatesText?: string } {
    if (!errorsMessagesData?.find((val) => val?.orderNumber)) {
      return {};
    }

    const missingRatesText =
      'Orders numbers: ' +
      errorsMessagesData
        .filter((val) => val?.orderNumber)
        .map((val) => val.orderNumber)
        .join(', ');
    return {
      ordersMissingRatesText: missingRatesText,
    };
  }

  private updateCarrierDataProperty<CarrierCacheDataKey extends keyof CarrierCachedData>(
    carrierId: number,
    property: CarrierCacheDataKey,
    value: CarrierCachedData[CarrierCacheDataKey],
  ) {
    if (!this.cachedDataByCarriers.has(carrierId) || !property || typeof value === undefined) {
      return;
    }
    const carrierData = this.cachedDataByCarriers.get(carrierId);
    carrierData[property] = value;
    this.cachedDataByCarriers.set(carrierId, carrierData);
  }

  private getCarrierDataProperty<CarrierCacheDataKey extends keyof CarrierCachedData>(
    carrierId: number,
    property: CarrierCacheDataKey,
  ) {
    if (!this.cachedDataByCarriers.has(carrierId)) {
      return;
    }
    const carrierData = this.cachedDataByCarriers.get(carrierId);
    return carrierData[property];
  }

  private updateRatesDataForAllOrders(
    serviceLevelOptimalProviderRates: IServiceLevelProviderChosenRates,
    selectedServiceLevel: string,
  ) {
    for (const row of this.rows) {
      let orderRateData = serviceLevelOptimalProviderRates.ordersRatesDetails?.find(
        (val) => val.orderId === row.orderId,
      );
      if (orderRateData) {
        let currentSelectedRatesDetails, originalRateData;
        const selectedData = this.getBatchSelectedRatesForOrder(row.orderId);
        if (
          selectedData &&
          selectedData.carrierServiceLevelInternalToken != orderRateData.carrierServiceLevelInternalToken
        ) {
          currentSelectedRatesDetails = selectedData;
          originalRateData = orderRateData;
          orderRateData = currentSelectedRatesDetails ?? orderRateData;
        }
        this.setRateSpecificRowData(row, orderRateData);
        row.serviceLevelOptions = this.generateDropDownOptionsArrayForServiceLevelSelection(
          orderRateData.orderId,
          this.selectedProvider,
        );
        row.sizeOptions = this.generateBoxesDropDownOptionsByServiceLevelAndProvider(
          selectedServiceLevel,
          row?.orderId ?? null,
          serviceLevelOptimalProviderRates.provider,
        );

        this.proccessReceivedRatesMessagesData(row, !row.serviceLevelOptions?.length);
        row.switchedToSelectedRate = currentSelectedRatesDetails?.carrierServiceLevelName;
        row.originalRecommendedRate = originalRateData?.carrierServiceLevelName;
        row.nonRecommendedServiceLevel =
          !currentSelectedRatesDetails &&
          this.getNonRecommendedServiceLevel(
            row.recommendedServiceLevelNames,
            orderRateData.carrierServiceLevelInternalToken,
            orderRateData.carrierServiceLevelName,
          );
        if (row.nonRecommendedServiceLevel) {
          row.isRecommendedServiceLevelExist = this.getIsRecommendedServiceLevelExist(row.recommendedServiceLevelNames);
        }
        row.recommendedServiceLevelNamesForDisplay = this.getRecommendedServiceLevelNamesForDisplay(
          row?.recommendedServiceLevelNames,
        );
      }

      const missingOrderRateInfo = serviceLevelOptimalProviderRates.ordersMissingRatesDetails?.find(
        (val) => val.orderId === row.orderId,
      );
      if (missingOrderRateInfo) {
        this.setRateSpecificRowData(row, null);
        row.serviceLevelOptions = null;
        row.sizeOptions = this.generateBoxesDropDownOptionsByServiceLevelAndProvider(
          selectedServiceLevel,
          row?.orderId ?? null,
          serviceLevelOptimalProviderRates.provider,
        );

        this.proccessReceivedRatesMessagesData(row, true);
      }
      row.isSaturdayDelivery =
        this.ordersShippingAdditionalData?.find((val) => val.orderId === row.orderId)?.isSaturdayDelivery ?? false;
      row.isShowSaturdayDeliveryCheckbox = this.isShowSaturdayDeliveryOption;
      const orderShippingAdditionalData = this.ordersShippingAdditionalData?.find((val) => val.orderId === row.orderId);
      if (orderShippingAdditionalData) {
        orderShippingAdditionalData.isShouldTrySuggestedAddress = !!row.isShouldTrySuggestedAddress;
        orderShippingAdditionalData.isTriedSuggestedAddress = !!row.isTriedSuggestedAddress;
      } else {
        this.ordersShippingAdditionalData.push({
          orderId: row.orderId,
          isShouldTrySuggestedAddress: !!row.isShouldTrySuggestedAddress,
          isTriedSuggestedAddress: !!row.isTriedSuggestedAddress,
          isSaturdayDelivery: false,
        });
      }
    }
  }

  async resetProviderSpecificBoxesData(
    serviceLevelProviderRatesData: IServiceLevelProviderChosenRates,
    resetToInitialBoxes?: boolean,
  ) {
    this.currentBoxesSelections?.forEach((boxSelection) => {
      const boxId = boxSelection.box?.id;
      const orderId = boxSelection.orderId;
      const isCommon = !!this.commonBoxesOptions?.find((val) => val.id === boxId);
      const isNewServiceLevelProviderSupports = !!serviceLevelProviderRatesData?.providerSpecificBoxes?.find(
        (val) => val.id === boxId,
      );
      const newProviderSupportsCurrentBox = isCommon || isNewServiceLevelProviderSupports;

      if (orderId && boxId && (!newProviderSupportsCurrentBox || resetToInitialBoxes)) {
        const row = this.rows.find((val) => val.orderId === orderId);

        let resetBoxData: IOrderSelectedBox;
        if (resetToInitialBoxes) {
          resetBoxData = this.initialBoxesSelections?.find((val) => val.orderId === orderId);
        } else {
          resetBoxData = this.lastCommonBoxesSelections?.find((val) => val.orderId === orderId);
        }

        if (resetBoxData?.box?.id) {
          const cachedBoxRatesData = this.getCachedOrdersRatesDataByBoxId(resetBoxData.box.id);

          this.updateNewBoxesAndRatesData([row], cachedBoxRatesData);
        }
      }
    });
  }

  purchaseLabelsForAllOrders() {
    const ordersToSendBack = this.rows?.filter((val) => val.isDisabledForPurchasing);
    if (ordersToSendBack?.length > 0) {
      this.removeInvalidOrdersAndConfirm(ordersToSendBack);
    } else {
      this.confirm();
    }
  }

  purchaseLabelsForSelectedOrders() {
    if (!this.userSelectedOrdersIds?.length) {
      return;
    }

    const ordersToSendBack = this.rows?.filter((val) => !this.userSelectedOrdersIds.includes(val?.orderId));
    if (ordersToSendBack?.length > 0) {
      this.removeInvalidOrdersAndConfirm(ordersToSendBack, { isRemoveUnselectedOrders: true });
    } else {
      this.confirm();
    }
  }

  private getTextForRemoveOrdersDialog(
    ordersToSendBack: ProccessedSingleOrderRate[],
    metadata?: {
      isRemoveUnselectedOrders?: boolean;
    },
  ) {
    const texts = [];

    if (metadata?.isRemoveUnselectedOrders) {
      if (ordersToSendBack.length === 1) {
        texts.push(
          `Order #${ordersToSendBack[0]?.orderNumber} will be excluded from this batch and stay in the Assign screen`,
        );
      } else {
        texts.push(`Some of these orders will be excluded from this batch and stay in the Assign screen`);
        texts.push(`The excluded orders are:
        ${ordersToSendBack.map((val) => `#${val.orderNumber} `)}`);
      }
    } else {
      if (ordersToSendBack.length === 1) {
        texts.push(`Order #${ordersToSendBack[0]?.orderNumber} is missing shipping rates and can't be assigned for delivery.
        It'll be excluded from this batch and stay in the Assign screen`);
      } else {
        texts.push(`Some of these orders are missing shipping rates and can't be assigned for delivery.
        They'll be excluded from this batch and stay the Assign screen`);
        texts.push(`The orders missing shipping rates are:
        ${ordersToSendBack.map((val) => `#${val.orderNumber} `)}`);
      }
    }

    return texts;
  }

  private async removeInvalidOrdersAndConfirm(
    ordersToSendBack: ProccessedSingleOrderRate[],
    metadata?: {
      isRemoveUnselectedOrders?: boolean;
    },
  ) {
    try {
      const ordersIdsToSendBack = ordersToSendBack.map((val) => val.orderId);
      const texts = this.getTextForRemoveOrdersDialog(ordersToSendBack, metadata);

      const dialogRef = this.dialog.open(TextDialogComponent, {
        width: '37vw',
        maxWidth: '80vw',
        backdropClass: 'global_modal_overlay_subdued',
        panelClass: 'overflow-visible-class',
        data: {
          bodyTexts: texts,
          headerText: 'Assign partial batch?',
          confirmButtonText: 'Continue',
          cancelButtonText: 'Cancel',
          onConfirm: async () => {
            await this.orderBatchService.deleteSelectedOrdersFromUnconfirmedBatch(ordersIdsToSendBack);
          },
        },
      });

      dialogRef.afterClosed().subscribe(async (responceData: { isSuccessOnConfirm?: boolean }) => {
        if (responceData?.isSuccessOnConfirm) {
          this.removeSelectedOrdersRatesData(ordersIdsToSendBack);
          this.generateInvalidOrdersErrorMessages();
          if (this.rows?.length > 0) {
            this.confirm();
          }
        }
      });
    } catch (e) {
      return false;
    }
  }

  // Callbacks related to purchasing batch labels
  confirm(): void {
    if (!this.isLoadingRates()) {
      this.confirming = true;

      const serviceLevelId = this.orderBatch.selectedCarrier?.serviceLevels?.find((value) => {
        return value.type === this.selectedServiceLevel;
      })?.id;

      //translate serviceLevel value while using the displayName
      const selectedSericeLevel = Object.values(ServiceLevelDisplayNames).includes(
        this.selectedServiceLevel as ServiceLevelDisplayNames,
      )
        ? mappingDisplayNameToServiceLevel(this.selectedServiceLevel)
        : this.selectedServiceLevel;

      const chosenRatesData = generateConfirmChosenRatesData(
        this.serviceLevelsRates,
        selectedSericeLevel,
        this.selectedProvider,
      );

      // If carrier provided us with service levels options for orders, we have to send to the backend
      // array of service levels id's that where selected by user in smart batch screen. Array 'row' holds
      // data about last selected service levels for each order, hence we use it while build our rates array
      if (this.allOrdersRates && chosenRatesData) {
        const lastChosenRatesDetails = this.rows.map((row) => {
          if (row.currentRateObject) {
            return row.currentRateObject;
          }

          const lastChosenOrderRate = row[SERVICE_LEVEL_NAME_FIELD];
          const rate = this.allOrdersRates
            .find((val) => {
              return val.orderId === row.orderId;
            })
            ?.rates?.find((val) => {
              return val.carrierServiceLevelName === lastChosenOrderRate;
            });

          return rate ?? null;
        });

        chosenRatesData.ordersRatesDetails = lastChosenRatesDetails;
      }

      this.orderBatchService
        .confirmBatch(
          this.data.batch.id,
          this.data.batch.additionalName,
          chosenRatesData,
          serviceLevelId,
          this.currentBoxesSelections,
          this.selectedOffsetOption,
          this.multiLabelSelectedOrderBoxes,
          this.ordersShippingAdditionalData,
          this.isBestMatch && { selectedCarrierId: this.selectedCarrierId },
          this.recommendedCheapestQuickestLog,
          this.data?.addToBatchId,
          this.isSaturdayDeliveryChosen,
        )
        .then((res) => {
          if (!res) {
            this.showFailSnackbar();
          }
          this.dialogRef.close({ closeDialog: true });

          if (this.forceFulfillScreenNavigate) {
            this.router.navigate(['/dashboard/fulfill/']);
          }
          this.confirming = false;
        });
    }
  }

  showFailSnackbar() {
    this._snackBar.openFromComponent(SnackbarWrapperComponent, {
      verticalPosition: 'top',
      panelClass: ['snackbar', 'snackbar__danger'],
      duration: 3000,
      data: {
        message: 'Failed to assign batch',
      },
    });
  }

  closeWindow(closePrevious: boolean) {
    this.isWaitingForBatchRemove = true;
    this.printService.deleteUnConfirmedBatch(this.data.batch).subscribe({
      next: (res) => {
        this.isWaitingForBatchRemove = false;
        this.dialogRef.close({ closeDialog: closePrevious });
      },
      error: (res) => {
        this.isWaitingForBatchRemove = false;
      },
    });
  }

  closeWindowIfBatchIsEmpty() {
    if (!(this.rows?.length > 0)) {
      this.printService.deleteUnConfirmedBatch(this.data.batch).subscribe((res) => {
        this.dialogRef.close({ closeDialog: true });
      });
    }
  }

  // Callbacks related to changing dropdown option of one of columns (service level + box selections)
  changeColumnDropdownOption(event: BatchRatesTableDropDownOnClickData) {
    if (event?.ordersIds?.includes && event?.property && event?.selectedOption) {
      const changedRows = this.rows.filter((value: ProccessedSingleOrderRate) => {
        return value.orderId && event.ordersIds.includes(value.orderId);
      });

      if (changedRows.length > 0) {
        if (event.property === SERVICE_LEVEL_NAME_FIELD) {
          changedRows.forEach((val: ProccessedSingleOrderRate) => {
            let selectedOption = event.selectedOption;
            if (event.rowToOptionMap) {
              selectedOption = event.rowToOptionMap.get(val.orderId);
            }
            this.changeRateServiceLevel(val, selectedOption);
          });
        } else if (event.property === BOX_ID_NAME_FIELD) {
          this.changeOrdersPackageDimensions(changedRows, event.selectedOption?.value);
        }

        this.rows = [...this.rows];
        if (this.isBestMatch && this.selectedCarrierId) {
          this.rowsByCarriers.set(this.selectedCarrierId, this.rows);
        }
        this.generateAnalyzedBatchData();
      }
    }
  }

  getSelectedServiceLevelProviders() {
    const selectedServiceLevelData = this.serviceLevelsRates?.find((val) =>
      isServiceLevelsEquals(val.serviceLevel, this.selectedServiceLevel),
    );
    const providers = selectedServiceLevelData?.ratesPerProviders?.map((val) => val.provider);

    return providers;
  }

  getCarrierSelectionNameForBestMatch() {
    const carrierName = this.getCarrierDataProperty(this.selectedCarrierId, CarrierCachedFieldNames.NAME);
    const currentServiceLevelData = this.serviceLevelsRatesByCarriers
      .get(this.selectedCarrierId)
      ?.find((val) => isServiceLevelsEquals(val.serviceLevel, this.selectedServiceLevel));
    let selectedProvider;
    if (currentServiceLevelData?.ratesPerProviders?.length) {
      selectedProvider = this.selectedProvider;
    }
    return carrierName + `${selectedProvider ? ' - ' + selectedProvider : ''}`;
  }

  getSortedProvidersForBestMatch() {
    const carrierIds = this.cachedDataByCarriers && [...this.cachedDataByCarriers.keys()];
    let providers: MatMenuListItem[] = [];
    for (const carrierId of carrierIds) {
      const carrierName = this.getCarrierDataProperty(carrierId, CarrierCachedFieldNames.NAME);
      const carrierData = this.cachedDataByCarriers.get(carrierId);
      const currentServiceLevelData =
        this.serviceLevelsRatesByCarriers
          .get(carrierId)
          ?.find((val) => isServiceLevelsEquals(val.serviceLevel, this.selectedServiceLevel)) ||
        // fallback to first service level tab(some carriers have only one service level tab)
        this.serviceLevelsRatesByCarriers.get(carrierId)?.[0];

      if (currentServiceLevelData?.ratesPerProviders?.length) {
        providers = providers.concat(
          currentServiceLevelData.ratesPerProviders.map((val) => {
            const providerAnalyzedData = carrierData.analyzedDataByProviders.get(val.provider);
            const arrivingOnTimeStr =
              !val.ordersMissingRatesDetails?.length &&
              isNumber(this.ordersCount) &&
              !providerAnalyzedData?.ordersUnknownDeliveryPromiseCount &&
              isNumber(providerAnalyzedData?.ordersArrivingOnTimeCount)
                ? `(${providerAnalyzedData.ordersArrivingOnTimeCount}/${this.ordersCount} on time)`
                : `(Missing data)`;
            const totalShipmentCostDisplayStr =
              !val.ordersMissingRatesDetails?.length && providerAnalyzedData?.batchTotalShipmentCost
                ? `(${providerAnalyzedData.batchTotalShipmentCost})`
                : `(Missing data)`;
            return {
              carrierId,
              name: val.provider,
              displayName: `${carrierName?.length <= 11 ? carrierName : carrierName.substring(0, 3) + '...'} - ${
                val.provider
              }`,
              arrivingOnTime: +providerAnalyzedData?.ordersArrivingOnTimeCount || 0,
              arrivingOnTimeDisplayString: arrivingOnTimeStr,
              totalShipmentCost: +providerAnalyzedData?.batchTotalShipmentCost?.replace(/\$/g, ''),
              totalShipmentCostDisplayString: totalShipmentCostDisplayStr,
            };
          }),
        );
      } else {
        providers = providers.concat({
          carrierId: carrierId,
          name: carrierName,
          displayName: carrierName?.length <= 15 ? carrierName : carrierName.substring(0, 3) + '...',
          arrivingOnTime: 0,
          arrivingOnTimeDisplayString: `(Missing data)`,
          totalShipmentCost: undefined,
          totalShipmentCostDisplayString: `(Missing data)`,
        });
      }
    }
    providers = this.sortProviders(providers);
    return providers;
  }

  sortProviders(providers: MatMenuListItem[]) {
    if (!providers) return;
    providers = providers.sort((a, b) => {
      //first sort by entire data before missing data orders
      if (
        (!a.totalShipmentCostDisplayString.includes('Missing data') &&
          b.totalShipmentCostDisplayString.includes('Missing data')) ||
        (!a.arrivingOnTimeDisplayString.includes('Missing data') &&
          b.arrivingOnTimeDisplayString.includes('Missing data'))
      ) {
        return -1;
      }
      if (
        (a.totalShipmentCostDisplayString.includes('Missing data') &&
          !b.totalShipmentCostDisplayString.includes('Missing data')) ||
        (a.arrivingOnTimeDisplayString.includes('Missing data') &&
          !b.arrivingOnTimeDisplayString.includes('Missing data'))
      ) {
        return 1;
      }

      //second sort by mostly arriving on time orders
      if (a.arrivingOnTime > b.arrivingOnTime) {
        return -1;
      }
      if (a.arrivingOnTime < b.arrivingOnTime) {
        return 1;
      }

      //third - sort by chepaest total shipment cost
      const aValue = a.totalShipmentCost;
      const bValue = b.totalShipmentCost;
      return isNumber(aValue) && isNumber(bValue) ? aValue - bValue : (bValue || 0) - (aValue || 0);
    });
    return providers;
  }

  trackByFn(idx: number, item: MatMenuListItem) {
    return item?.carrierId;
  }

  // Function we call if changed option is order box selection
  private async changeOrdersPackageDimensions(rows: ProccessedSingleOrderRate[], selectedOption: any) {
    const boxId = Number(selectedOption);
    const { box, isCommonBox } = this.getBoxObjectByBoxId(boxId);

    if (!box || !rows) {
      return;
    }

    // First we check if we already have box related orders rates in local cache
    const cachedOrders = [];
    const ratesCache = this.getCachedOrdersRatesDataByBoxId(boxId);
    this.updateNewBoxesAndRatesData(rows, ratesCache, (row) => {
      cachedOrders.push(row.orderId);
    });

    // Next we generate order ids array, after filtering out orders with cached rates
    const uncachedOrders = rows.filter((val) => !cachedOrders.includes(val.orderId)).map((val) => val.orderId);

    const ratesResponce = await this.getOrdersRates(uncachedOrders, {
      boxId: box.id,
      carrierId: this.selectedCarrierId,
      ignoreInternalRates: true,
    });
    if (ratesResponce?.rateInfo) {
      const orderBatchRateInfo: IOrderBatchRateInfo = ratesResponce.rateInfo;
      if (orderBatchRateInfo?.totalServiceLevelsRatesData) {
        const newRates = orderBatchRateInfo.totalServiceLevelsRatesData;
        this.updateBoxRatesCacheData(newRates, box?.id, orderBatchRateInfo?.carrier?.id);
        this.updateNewBoxesAndRatesData(rows, newRates);
      }
    } else if (ratesResponce?.rateInfoList) {
      // Best match approach - retrieving rates for all carriers together
      const orderBatchRateInfoList: IOrderBatchRateInfo[] = ratesResponce.rateInfoList;
      // TODO: version 2 of best match
    }

    this.rows = [...this.rows];
    if (this.isBestMatch && this.selectedCarrierId) {
      this.rowsByCarriers.set(this.selectedCarrierId, this.rows);
    }
    this.generateAnalyzedBatchData();
  }

  private async getOrdersRates(
    ordersIds: string[],
    additionalParams?: {
      hoursOffset?: number;
      boxId?: number;
      carrierId?: number;
      ignoreInternalRates?: boolean;
    },
  ): Promise<{ rateInfo?: IOrderBatchRateInfo | null; rateInfoList?: IOrderBatchRateInfo[] | null }> {
    let ratesResponce = null;

    if (ordersIds?.length > 0 && this.orderBatch?.id) {
      this.setRowsLoadingMode(ordersIds, true);
      let carrierToFetch;
      if (this.isBestMatch) {
        carrierToFetch = { carrierToFetch: additionalParams?.carrierId ?? 'All' };
      }
      try {
        ratesResponce = await this.orderService.getOrdersRates(
          ordersIds,
          this.orderBatch?.id,
          additionalParams?.boxId,
          additionalParams?.hoursOffset ?? this.selectedOffsetOption,
          this.ordersShippingAdditionalData,
          undefined,
          carrierToFetch,
          additionalParams?.ignoreInternalRates,
        );
      } catch (e) {
        console.log('Failed to fetch rates data from backend');
      }

      this.setRowsLoadingMode(ordersIds, false);
    }

    return ratesResponce;
  }

  private getBoxObjectByBoxId(boxId: number): { isCommonBox: boolean; box: IBoxSizeData | null } {
    const commonBox = this.commonBoxesOptions?.find((box) => box?.id === boxId);
    if (commonBox) {
      return {
        box: { ...commonBox },
        isCommonBox: true,
      };
    }

    let serviceLevelProviderSpecificBox: IBoxSizeData | null = null;
    this.serviceLevelsRates.forEach((serviceLevelRatesData) => {
      serviceLevelRatesData.ratesPerProviders?.forEach((serviceLevelFinalProviderRates) => {
        const providerBox = serviceLevelFinalProviderRates?.providerSpecificBoxes?.find((box) => {
          return box.id === boxId;
        });

        if (providerBox) {
          serviceLevelProviderSpecificBox = { ...providerBox };
        }
      });
    });

    return {
      box: serviceLevelProviderSpecificBox ?? null,
      isCommonBox: false,
    };
  }

  private updateNewBoxesAndRatesData(
    rows: ProccessedSingleOrderRate[],
    newRatesData: TruncatedRatesData,
    callbackFn?: (row: ProccessedSingleOrderRate) => void,
  ) {
    try {
      const newServiceLevelsRates = newRatesData?.selectedServiceLevelsRates;

      rows?.forEach((row) => {
        const newOrderRatesOptions = newRatesData?.ordersRatesOptions?.find((val) => val.orderId === row?.orderId);
        const newOrderParsel = newRatesData?.selectedOrdersBoxes?.find((val) => val.orderId === row?.orderId)?.box;
        const newOrderMessages = newRatesData?.ordersRatesMessages?.find(
          (orderMessages) => orderMessages?.orderId === row?.orderId,
        );
        if (newOrderMessages) {
          const index = this.ordersMessages.findIndex((val) => val?.orderId === row?.orderId);
          this.ordersMessages[index] = newOrderMessages;
        }

        // TODO: update to support situation where carrier does not provider rates options array at all
        // If we found rates options for current order, we also assume that we have
        // chosen one of those options to all of carrier service level chosen rates sets
        if (newOrderRatesOptions && newServiceLevelsRates) {
          this.proccessOrderNewBoxSelectionRatesData(row, newOrderRatesOptions, newServiceLevelsRates, newOrderParsel);
          if (callbackFn) {
            callbackFn(row);
          }
        }
      });

      this.proccessEmptyStateData();
      this.generateInvalidOrdersErrorMessages();
      this.proccessSuggestedAddressesUsageData();
    } catch (e) {
      console.log('Error: ', e);
    }
  }

  private proccessSuggestedAddressesUsageData() {
    this.isShowSuggestedAddressesBanner = this.rows?.some((row) => row && row.isTriedSuggestedAddress);
  }

  private proccessOrderNewBoxSelectionRatesData(
    row: ProccessedSingleOrderRate,
    newAllOrderRates: IAllOrderRates,
    newServiceLevelsRates: TruncatedServiceLevelRatesData[],
    box: IBoxSizeData,
  ) {
    const orderIdToUpdate = row?.orderId;
    if (!orderIdToUpdate) {
      return;
    }

    // Here we update order all possible rates, updated for new package size
    const allOrderRates = this.allOrdersRates.find((val) => val.orderId === orderIdToUpdate);
    allOrderRates.rates = newAllOrderRates.rates;

    // Here we update service levels rates data for current row order number
    this.serviceLevelsRates.forEach((currServiceLevelRates) => {
      const newServiceLevelRates = newServiceLevelsRates?.find((val) => {
        return isServiceLevelsEquals(val?.serviceLevel, currServiceLevelRates?.serviceLevel);
      });

      const updatedProviders: string[] = [];
      currServiceLevelRates.ratesPerProviders?.forEach((oldProviderRates) => {
        const newProviderRates =
          newServiceLevelRates?.ratesPerProviders?.find((newProviderRates) => {
            return newProviderRates?.provider?.toLowerCase() === oldProviderRates?.provider?.toLowerCase();
          }) ?? null;
        this.updatePoviderRatesData(oldProviderRates, newProviderRates, row.orderId);
        updatedProviders.push(oldProviderRates?.provider?.toLowerCase());
      });

      const newlyCreatedProviders = newServiceLevelRates.ratesPerProviders?.filter((newProviderRates) => {
        return !updatedProviders.includes(newProviderRates.provider?.toLowerCase());
      });
      this.addNewProvidersRatesToServiceLevel(
        currServiceLevelRates,
        newlyCreatedProviders as IServiceLevelProviderChosenRates[],
      );
    });

    // update row data: updated service levels + new boxes selections for current row
    const selectedServiceLevelData = this.serviceLevelsRates.find((val) =>
      isServiceLevelsEquals(val.serviceLevel, this.selectedServiceLevel),
    );
    const selectedServiceLevelProviderRates = selectedServiceLevelData?.ratesPerProviders?.find((val) => {
      return val.provider === this.selectedProvider;
    });
    const selectedRate =
      selectedServiceLevelProviderRates?.ordersRatesDetails?.find((val) => val?.orderId === row?.orderId) ?? null;
    this.setRateSpecificRowData(row, selectedRate);
    this.setBoxSpecificRowData(row, box);

    row.serviceLevelOptions = this.generateDropDownOptionsArrayForServiceLevelSelection(
      row.orderId,
      this.selectedProvider,
    );

    const orderShippingData = this.ordersShippingAdditionalData?.find((val) => val.orderId === row.orderId);
    orderShippingData.isTriedSuggestedAddress = row.isTriedSuggestedAddress;
    orderShippingData.isShouldTrySuggestedAddress = row.isShouldTrySuggestedAddress;

    // update current box selections data;
    const currentBoxData = this.currentBoxesSelections?.find((val) => val.orderId === row.orderId);
    if (currentBoxData) {
      currentBoxData.box = box;
    }

    // if new selected box is a common box (for all providers), then update last common box selection
    if (this.isServiceLevelSpecificBox(box)) {
      const lastCommonBoxData = this.lastCommonBoxesSelections?.find((val) => val.orderId === row.orderId);
      lastCommonBoxData.box = box;
    }

    row.isSaturdayDelivery =
      this.ordersShippingAdditionalData?.find((val) => val.orderId === row.orderId)?.isSaturdayDelivery ?? false;
    row.isShowSaturdayDeliveryCheckbox = this.isShowSaturdayDeliveryOption;
  }

  private addNewProvidersRatesToServiceLevel(
    serviceLevelRates: IServiceLevelChosenRates,
    newProvidersRates: IServiceLevelProviderChosenRates[],
  ) {
    if (!newProvidersRates) {
      return;
    }

    for (const newProviderRates of newProvidersRates) {
      const providerMissingOrdersIds =
        this.rows
          ?.map((row) => row.orderId)
          ?.filter((orderId) => {
            const isNewProviderHasRate = newProviderRates.ordersRatesDetails?.find((rate) => rate?.orderId === orderId);
            const isNewProviderHasMissingRateData = newProviderRates.ordersMissingRatesDetails?.find(
              (rate) => rate?.orderId === orderId,
            );

            return !isNewProviderHasRate && !isNewProviderHasMissingRateData;
          }) ?? [];

      for (const missingOrderId of providerMissingOrdersIds) {
        if (!newProviderRates.ordersMissingRatesDetails) {
          newProviderRates.ordersMissingRatesDetails = [];
        }

        newProviderRates.ordersMissingRatesDetails.push({ orderId: missingOrderId });
      }

      serviceLevelRates.ratesPerProviders.push(newProviderRates as IServiceLevelProviderChosenRates);
    }
  }

  // TODO: when add orderId to row, update to add missing rate object even if not received from back
  private updatePoviderRatesData(
    storedProviderRates: IServiceLevelProviderChosenRates,
    newProviderRates: TruncatedServiceLevelProviderRatesData | null,
    orderId: string,
  ) {
    if (!storedProviderRates) {
      return;
    }

    const newProviderMissingRates = newProviderRates?.ordersMissingRatesDetails
      ? [...newProviderRates.ordersMissingRatesDetails]
      : [];
    const newProviderRatesDetails = newProviderRates?.ordersMissingRatesDetails
      ? [...newProviderRates.ordersRatesDetails]
      : [];

    // First we remove all possile rates data (or missing rates data objects) related to current order number
    storedProviderRates.ordersMissingRatesDetails = storedProviderRates.ordersMissingRatesDetails.filter((val) => {
      return val.orderId !== orderId;
    });
    storedProviderRates.ordersRatesDetails = storedProviderRates.ordersRatesDetails.filter((val) => {
      return val.orderId !== orderId;
    });

    const newOrderRate = newProviderRatesDetails?.find((val) => {
      return val.orderId === orderId;
    });
    const missingOrderRate = newProviderMissingRates?.find((val) => val.orderId === orderId);

    if (newOrderRate) {
      storedProviderRates.ordersRatesDetails.push(newOrderRate);
    } else if (missingOrderRate) {
      storedProviderRates.ordersMissingRatesDetails.push(missingOrderRate);
    } else {
      storedProviderRates.ordersMissingRatesDetails.push({ orderId: orderId });
    }
  }

  private isServiceLevelSpecificBox(box: IBoxSizeData) {
    if (!box?.id) {
      return false;
    }
    const res = this.commonBoxesOptions?.find((val) => val?.id === box.id);
    return res ? true : false;
  }

  private setBoxSpecificRowData(row: ProccessedSingleOrderRate, box: IBoxSizeData) {
    if (box?.id && box?.name) {
      row.boxId = box.id;
      row.boxName = box.name;
      row.boxSize = this.generateBoxMeasuresString(box);
    }

    row.sizeOptions = this.generateBoxesDropDownOptionsByServiceLevelAndProvider(
      this.selectedServiceLevel,
      row?.orderId ?? null,
      this.selectedProvider,
    );
  }

  private generateBoxesDropDownOptionsByServiceLevelAndProvider(
    serviceLevel: string,
    orderId: string | null,
    provider?: string,
  ) {
    const boxesOptions = [...this.commonBoxesOptions];
    const selectedServiceLevelRatesData = this.serviceLevelsRates?.find((rate) =>
      isServiceLevelsEquals(rate?.serviceLevel, serviceLevel),
    );

    let serviceLevelOptimalProviderRates: IServiceLevelProviderChosenRates | null = null;
    if (provider) {
      serviceLevelOptimalProviderRates = selectedServiceLevelRatesData?.ratesPerProviders?.find(
        (val) => val?.provider && val.provider === provider,
      );
    } else {
      serviceLevelOptimalProviderRates = selectedServiceLevelRatesData?.ratesPerProviders?.find(
        (val) => val?.isOptimal,
      );
    }

    if (serviceLevelOptimalProviderRates?.providerSpecificBoxes && boxesOptions) {
      serviceLevelOptimalProviderRates.providerSpecificBoxes.forEach((providerBox) => {
        if (!boxesOptions.find((box) => box.id === providerBox.id)) {
          boxesOptions.push(providerBox);
        }
      });
      // boxesOptions = boxesOptions.concat(serviceLevelOptimalProviderRates.providerSpecificBoxes);
    }

    const boxesProccessedOptions = this.generateDropDownOptionsArrayForBoxesSelection(boxesOptions, orderId);

    return boxesProccessedOptions ?? null;
  }

  // Function we call if changed options is service level selection
  private changeRateServiceLevel(row: ProccessedSingleOrderRate, selectedOption: any) {
    // use selected option as index,
    // in case we have serveral same service levels
    const searchedRate = this.allOrdersRates
      .find((allRatesObj) => {
        return allRatesObj.orderId === row.orderId;
      })
      .rates.filter((rate) => {
        return rate.provider === selectedOption?.provider;
      })
      // important to have same sort order as for generateDropDownOptionsArrayForServiceLevelSelection(otherwise index won't match):
      .sort((valA, valB) => {
        return valA.price - valB.price;
      })
      .find?.((rate, index) => {
        return index === selectedOption?.value;
      });

    // Move this code to its own row
    if (searchedRate) {
      this.setRateSpecificRowData(row, searchedRate);
    } else {
      this.setRateSpecificRowData(row, null);
    }
  }

  // Here arugment 'newRate' can be 'null'. So, use conditional chaining operator, when you use this argument
  private setRateSpecificRowData(row: ProccessedSingleOrderRate, newRate: IOrderRateDetails | null) {
    if (
      row.serviceLevelName !== newRate?.carrierServiceLevelName &&
      row.currentRateObject &&
      row.currentRateObject.provider === newRate?.provider
    ) {
      console.log(
        `Change service level rate for order ${row.orderId} from ${row.serviceLevelName} to ${newRate?.carrierServiceLevelName}`,
      );
    }
    row.currentRateObject = newRate;
    const convertedPrice = this.getCurrencyConvertedPrice(newRate?.price, newRate?.currency);
    row.ratePrice = newRate?.price ? `${this.currencySign}${convertedPrice}` : null;
    row.serviceLevelName = newRate?.carrierServiceLevelName ?? null;
    row.serviceLevelId = newRate?.carrierServiceLevelId ?? null;

    let deliveryDate: Date | null = null;
    const estimatedDeliveryDateStr = newRate?.deliveryDateEstimationInfo?.estimatedDeliveryDateRange?.max;
    if (estimatedDeliveryDateStr) {
      deliveryDate = this.generateValidDateObject(estimatedDeliveryDateStr);
    }
    row.estimationRateDeliveryDate = deliveryDate ?? null;
    row.estimationRateDeliveryDateStr = deliveryDate ? this.formatEstimatedDateString(deliveryDate) : null;

    const deliveryPromise = row.orderPromiseDeliveryDate;
    const { status, print } = this.generateDeliveryPredictionStatusData(deliveryPromise, deliveryDate);
    row.deliveryTimePredictionStatus = status;
    row.deliveryTimePredictionStatusPrint = print;

    const deliveryEstimationInfo = newRate?.deliveryDateEstimationInfo;
    row.etaFromPickupPrint = deliveryEstimationInfo ? this.generateETAFromPickupText(deliveryEstimationInfo) : null;
    row.isDisabledForPurchasing = newRate ? false : true;
    row.isInternalRateCardPrice = newRate?.isInternalRateCardPrice;

    // Update errors messages
    this.proccessReceivedRatesMessagesData(row, !newRate);
  }

  fireColumnButtonEvent(event: BatchRatesTableButtonEventData) {
    const eventName = event?.event;

    if (eventName === SaveAsBatchEventNames.DETACH_ORDER) {
      const eventOrdersIds = event?.ordersIds;

      const orderNumbers: number[] = this.orderBatch?.orders
        ?.filter((val) => eventOrdersIds?.includes(val?.id))
        ?.map((val) => +val.orderNumber);

      if (eventOrdersIds?.length > 0) {
        // const dialogRef = this.dialog.open(BacktosingleorderComponent, {
        //   maxWidth: '100vw',
        //   width: '35vw',
        //   panelClass: 'overflow-visible-class',
        //   backdropClass: 'global_modal_overlay',
        //   data: {
        //     orderIds: eventOrdersIds,
        //     orderNumbers: orderNumbers,
        //     selectedOrdersToAssign: true,
        //     detachFromUnconfirmedBatch: true,
        //   },
        // });

        const dialogRef = this.dialog.open(TextDialogComponent, {
          width: '37vw',
          maxWidth: '80vw',
          backdropClass: 'global_modal_overlay_subdued',
          panelClass: 'overflow-visible-class',
          data: {
            bodyTexts: [
              `You’re removing orders from this batch and moving them back to the Assign screen.
            Are you sure?`,
            ],
            headerText: 'Remove orders from batch?',
            confirmButtonText: 'Remove from batch',
            confirmButtonVariant: 'danger',
            cancelButtonText: 'Cancel',
            onConfirm: async () => {
              await this.orderBatchService.deleteSelectedOrdersFromUnconfirmedBatch(eventOrdersIds);
            },
          },
        });

        dialogRef.afterClosed().subscribe(async (responceData: { isSuccessOnConfirm?: boolean }) => {
          if (responceData?.isSuccessOnConfirm) {
            this.removeSelectedOrdersRatesData(eventOrdersIds);
            this.generateInvalidOrdersErrorMessages();
            this.closeWindowIfBatchIsEmpty();
          }
        });

        // dialogRef.afterClosed().subscribe(async (successfullyDeleted) => {
        //   if (successfullyDeleted) {
        //     this.removeSelectedOrdersRatesData(eventOrdersIds);
        //     this.generateInvalidOrdersErrorMessages();
        //     this.closeWindowIfBatchIsEmpty();
        //   }
        // });
      }
    }
  }

  private removeSelectedOrdersRatesData(ordersIds: string[]) {
    ordersIds.forEach((orderId) => {
      this.rows = this.rows.filter((row) => row.orderId !== orderId);
      this.allOrdersRates = this.allOrdersRates?.filter?.((orderRates) => orderRates.orderId !== orderId);
      this.serviceLevelsRates?.forEach((serviceLevelRates) => {
        serviceLevelRates.ratesPerProviders?.forEach((providerRates) => {
          providerRates.ordersRatesDetails = providerRates.ordersRatesDetails?.filter(
            (orderRate) => orderRate.orderId !== orderId,
          );
          providerRates.ordersMissingRatesDetails = providerRates.ordersMissingRatesDetails?.filter(
            (missingRatesData) => {
              return missingRatesData.orderId !== orderId;
            },
          );
        });
      });

      this.initialBoxesSelections = this.initialBoxesSelections?.filter((val) => val.orderId !== orderId);
      this.lastCommonBoxesSelections = this.lastCommonBoxesSelections?.filter((val) => val.orderId !== orderId);
      this.currentBoxesSelections = this.currentBoxesSelections?.filter((val) => val.orderId !== orderId);

      this.deletedOrdersIds.push(orderId);
    });
    if (this.isBestMatch && this.selectedCarrierId) {
      this.rowsByCarriers.set(this.selectedCarrierId, this.rows);
      this.allOrdersRatesByCarriers.set(this.selectedCarrierId, this.allOrdersRates);
      this.serviceLevelsRatesByCarriers.set(this.selectedCarrierId, this.serviceLevelsRates);
      this.initialBoxesSelectionsByCarriers.set(this.selectedCarrierId, this.initialBoxesSelections);
      this.lastCommonBoxesSelectionsByCarriers.set(this.selectedCarrierId, this.lastCommonBoxesSelections);
      this.currentBoxesSelectionsByCarriers.set(this.selectedCarrierId, this.currentBoxesSelections);
    }

    this.initializeBasicBatchData();
    this.generateAnalyzedBatchData();
  }

  // Next functions are utility function that help us to proccess order rate data
  private generateDeliveryPredictionStatusData(
    deliveryPromise: Date | null,
    deliveryDate: Date | null,
    isPickup?: boolean,
  ): { status: DeliveryTimeStatus; print: string } {
    let status;
    let print;

    if (isPickup) {
      status = DeliveryTimeStatus.FOR_PICKUP;
      print = 'No data';
    } else if (!deliveryPromise || !deliveryDate) {
      status = DeliveryTimeStatus.UNKNOWN;
      print = 'No data';
    } else if (deliveryDate && deliveryPromise) {
      if (deliveryDate <= deliveryPromise) {
        status = DeliveryTimeStatus.INTIME;
        print = 'On time';
      } else {
        status = DeliveryTimeStatus.LATE;
        print = this.generateLateDeliveryPromiseText(deliveryDate, deliveryPromise);
      }
    }

    return { status, print };
  }

  // TODO: add interface + add code that convertes it to shop locale timezone
  private generateValidDateObject(estimatedDeliveryDate?: string): Date | null {
    if (!estimatedDeliveryDate) {
      return null;
    }
    const date = new Date(estimatedDeliveryDate);
    if (!date || !isNumber(date.getTime?.()) || date.getTime() === 0) {
      return null;
    }
    return date;
  }

  private generateETAFromPickupText(data: IShipmentDeliveryDateEstimation): string | null {
    const maxHours = data?.deliveryTimeRangeInHours?.max;
    const minHours = data?.deliveryTimeRangeInHours?.min;

    if (isNumber(maxHours) && !minHours) {
      const days = Math.ceil(maxHours / 24);
      const isSameDay = new Date().getUTCDate() === new Date(data?.estimatedDeliveryDateRange?.max).getUTCDate();

      if (days > 0 && !isSameDay) {
        return `${days} business ${days === 1 ? 'day' : 'days'}`;
      }

      if (days === 0 || isSameDay) {
        return 'Same Day';
      }
    }

    if (isNumber(maxHours) && isNumber(minHours)) {
      const minDays = Math.ceil(minHours / 24);
      const maxDays = Math.ceil(maxHours / 24);

      if (minDays > 0 && maxDays > 0) {
        if (minDays !== maxDays) {
          return `${minDays}-${maxDays} business days`;
        } else {
          return `${maxDays} business ${maxDays === 1 ? 'day' : 'days'}`;
        }
      }
    }
    return ERROR_TEXT;
  }

  private generateLateDeliveryPromiseText(deliveryDate: Date, deliveryPromise: Date) {
    if (!deliveryDate || !deliveryPromise) {
      return ERROR_TEXT;
    }

    let daysDifference = getRawDatesDifferenceInDays(deliveryDate, deliveryPromise);
    if (isNumber(daysDifference) && daysDifference < 0) {
      daysDifference = Math.ceil(daysDifference * -1);
      return `Late by ${daysDifference} ${daysDifference > 1 ? 'days' : 'day'}`;
    } else {
      return ERROR_TEXT;
    }
  }

  private performInitialSort() {
    this.rows.sort((valA, valB) => {
      const deliveryPromiseCompare = this.compareRowField(
        SmartBatchColumnsProps.DELIVERY_PROMISE_STATUS,
        'ASC',
        valA[SmartBatchColumnsProps.DELIVERY_PROMISE_STATUS],
        valB[SmartBatchColumnsProps.DELIVERY_PROMISE_STATUS],
      );

      const shippingCostCompare = this.compareRowField(
        SmartBatchColumnsProps.ESTIMATED_SHIPMENT_COST,
        'DESC',
        valA[SmartBatchColumnsProps.ESTIMATED_SHIPMENT_COST],
        valB[SmartBatchColumnsProps.ESTIMATED_SHIPMENT_COST],
      );

      return deliveryPromiseCompare === 0 ? shippingCostCompare : deliveryPromiseCompare;
    });
  }

  private compareRowField(property: string, mode: 'DESC' | 'ASC', valueA: any, valueB: any): 0 | -1 | 1 {
    if (!property || (mode !== 'ASC' && mode !== 'DESC')) {
      return 0;
    }

    if (property === SmartBatchColumnsProps.DELIVERY_PROMISE_STATUS) {
      valueA = DELIVERY_TIME_STATUS_ORDER[valueA];
      valueB = DELIVERY_TIME_STATUS_ORDER[valueB];
    }

    if (
      property === SmartBatchColumnsProps.ESTIMATED_SHIPMENT_COST ||
      property === SmartBatchColumnsProps.CHARGED_FOR_SHIPPING
    ) {
      valueA = +valueA?.substring(1);
      valueB = +valueB?.substring(1);
    }

    if (mode === 'DESC') {
      if (valueA < valueB) return 1;
      if (valueA > valueB) return -1;
      return 0;
    } else {
      if (valueA > valueB) return 1;
      if (valueA < valueB) return -1;
      return 0;
    }
  }

  // Next functions are called from component's html template
  sortColumns(columnIndex: number) {
    let sortDirection: 'ASC' | 'DESC';
    let sortFieldName: string;

    // First we change columns config array (we update sorting direction of chosen column)
    // We fetch current sort direction, and flip this value in columns config array
    this.columns = this.columns.map((column: SaveAsBatchColumnSettings, i: number) => {
      if (i !== columnIndex) {
        return { ...column, sortDirection: null };
      }
      sortDirection = column.sortDirection === 'ASC' ? 'DESC' : 'ASC';
      sortFieldName = column.prop;
      return { ...column, sortDirection };
    });

    // Here we sort our 'rows' array by chosen field in chosen sort direction
    if (sortDirection && sortFieldName) {
      this.rows.sort((valA, valB) => {
        return this.compareRowField(sortFieldName, sortDirection, valA[sortFieldName], valB[sortFieldName]);
      });
      this.rows = [...this.rows];
      if (this.isBestMatch && this.selectedCarrierId) {
        this.rowsByCarriers.set(this.selectedCarrierId, this.rows);
      }
    }
  }

  isAssignOrdersButtonDisabled() {
    if (this.isLoadingRates() || !this.rows || !(this.rows.length > 0)) {
      return true;
    }
    return this.isMissingRatesForAllOrders() || this.invalidOrdersRatesErrorMessages?.length;
  }

  isAssignSelectedOrdersButtonDisabled() {
    if (this.isLoadingRates() || !this.rows || !(this.rows.length > 0) || !(this.userSelectedOrdersIds?.length > 0)) {
      return true;
    }
    return this.isMissingRatesForSelectedOrders(this.userSelectedOrdersIds);
  }

  onSelectRow(selectedIds: string[]) {
    this.userSelectedOrdersIds = selectedIds ?? [];
  }

  isMissingRatesForAllOrders() {
    if (!this.isRatesInitialized) {
      return false;
    }

    const invalidOrdersRates = this.rows?.filter((val) => val.isDisabledForPurchasing) ?? [];
    return !(this.rows?.length && invalidOrdersRates.length < this.rows.length);
  }

  isMissingRatesForSelectedOrders(ordersIds?: string[]) {
    if (!this.isRatesInitialized) {
      return true;
    }

    const invalidSelectedOrderRates = this.rows?.filter(
      (val) => val?.isDisabledForPurchasing && ordersIds.includes(val?.orderId),
    );
    return invalidSelectedOrderRates?.length;
  }

  generateInvalidOrdersErrorMessages(carrierId?: number) {
    this.invalidOrdersRatesErrorMessages = [];

    this.rows?.forEach((row) => {
      const orderMessages = this.ordersMessages?.find((orderMessages) => orderMessages?.orderId === row?.orderId);
      const hasApiErrors = !!orderMessages?.warningMessages?.find(
        (message) =>
          message?.code === ShipmentCreationErrorCode.PROVIDER_API_TIMEOUT &&
          message?.source === this.selectedProvider?.toLowerCase(),
      );

      if (hasApiErrors && row?.isDisabledForPurchasing) {
        this.invalidOrdersRatesErrorMessages.push({
          text: `Couldn't get rate for order #${row.orderNumber}. API didn't respond.`,
          orderId: row?.orderId,
          orderNumber: row?.orderNumber + '',
          type: 'api',
        });
      } else if (row?.isDisabledForPurchasing) {
        this.invalidOrdersRatesErrorMessages.push({
          text: `Couldn't get rate for order #${row.orderNumber}.`,
          orderId: row?.orderId,
          orderNumber: row?.orderNumber + '',
          type: 'default',
        });
      }
      if (row?.errors?.length) {
        row.errors.map((error) => {
          this.invalidOrdersRatesErrorMessages.push({
            text: `Order ${row.orderNumber} - ${error}`,
            orderId: row?.orderId,
            orderNumber: row?.orderNumber + '',
            type: 'default',
          });
        });
      }
    });

    this.invalidOrdersRatesErrorMessages = [...this.invalidOrdersRatesErrorMessages];
    if (this.isBestMatch && carrierId) {
      this.invalidOrdersRatesErrorMessagesByCarrier.set(carrierId, [...this.invalidOrdersRatesErrorMessages]);
    }

    this.processedErrorMessagesTexts = this.generateProcessedErrorMessagesTexts(this.invalidOrdersRatesErrorMessages);
  }

  /*
   *
   * TODO: Move all next functions to new class (data cache handler, or smthing like that)
   *
   */

  private saveInitialRatesDataToCache(
    newRatesData: IAllServiceLevelsRates,
    options?: { skipCacheInitialization?: boolean; carrierId?: number },
  ) {
    try {
      if (!options?.skipCacheInitialization) {
        this.initializeNewEmptyCacheMap(options?.carrierId);
      }
      if (!newRatesData?.selectedOrdersBoxes || !newRatesData?.selectedServiceLevelsRates) {
        return;
      }

      let selectedBoxesIds = newRatesData.selectedOrdersBoxes.map((val) => val?.box?.id);
      if (!selectedBoxesIds || !(selectedBoxesIds.length > 0)) {
        return;
      }

      selectedBoxesIds = [...new Set(selectedBoxesIds)];

      selectedBoxesIds.forEach((boxId) => {
        if (boxId) {
          const boxRelatedOrdersIds =
            newRatesData.selectedOrdersBoxes.filter((val) => val?.box?.id === boxId).map((val) => val.orderId) || [];
          const boxRelatedOrdersRateOptions = newRatesData.ordersRatesOptions?.filter((val) =>
            boxRelatedOrdersIds.includes(val.orderId),
          );

          const boxRelatedOrdersMessages = newRatesData.ordersRatesMessages?.filter((val) =>
            boxRelatedOrdersIds.includes(val.orderId),
          );

          const boxRelatedServiceLevelsRates: IServiceLevelChosenRates[] = [];
          newRatesData.selectedServiceLevelsRates?.forEach((serviceLevelData) => {
            const tempServiceLevelData = this.generateServiceLevelDataWithFilteredRatesByBox(
              serviceLevelData,
              boxRelatedOrdersIds,
            );
            boxRelatedServiceLevelsRates.push(tempServiceLevelData);
          });

          const boxRelatedParcelsData = newRatesData?.selectedOrdersBoxes?.filter((val) => {
            return val.box?.id === boxId;
          });

          if (boxRelatedServiceLevelsRates.length > 0) {
            const data = {
              senderCurrencyLocal: newRatesData?.senderCurrencyLocal,
              ordersRatesOptions: boxRelatedOrdersRateOptions,
              selectedServiceLevelsRates: boxRelatedServiceLevelsRates,
              selectedOrdersBoxes: boxRelatedParcelsData,
              ordersRatesMessages: boxRelatedOrdersMessages,
            };
            this.updateBoxRatesCacheData(data, boxId, options?.carrierId);
          }
        }
      });
    } catch (e) {
      console.log('Error during saving initial rates data to cache: ', e);
    }
  }

  private initializeNewEmptyCacheMap(carrierId?: number) {
    this.boxesRatesCache = new Map();
    if (this.isBestMatch) {
      if (!carrierId) {
        this.boxesRatesCacheByCarriers = new Map();
      } else {
        this.boxesRatesCacheByCarriers.set(carrierId, this.boxesRatesCache);
      }
    }
  }

  private generateServiceLevelDataWithFilteredRatesByBox(
    serviceLevelData: IServiceLevelChosenRates,
    ordersIds: string[],
  ) {
    const result: IServiceLevelChosenRates = {
      ...serviceLevelData,
      ratesPerProviders: [],
    };
    serviceLevelData?.ratesPerProviders?.forEach((providerRates) => {
      result.ratesPerProviders.push({
        provider: providerRates.provider,
        isOptimal: providerRates.isOptimal,
        ordersRatesDetails: providerRates?.ordersRatesDetails?.filter((val) => ordersIds.includes(val?.orderId)) ?? [],
        ordersMissingRatesDetails:
          providerRates?.ordersMissingRatesDetails?.filter((val) => ordersIds.includes(val?.orderId)) ?? [],
        providerSpecificBoxes: providerRates?.providerSpecificBoxes ?? null,
      });
    });

    return result;
  }

  private updateBoxRatesCacheData(newRatesData: IAllServiceLevelsRates, boxId: number, carrierId?: number) {
    try {
      if (!boxId) {
        return;
      }

      let cachedBoxRatesData: BoxesCachedRates;
      if (this.isBestMatch && carrierId) {
        cachedBoxRatesData = this.boxesRatesCacheByCarriers.get(carrierId)?.get(boxId);
      } else {
        cachedBoxRatesData = this.boxesRatesCache.get(boxId);
      }
      const newSelectedRatesData = newRatesData.selectedServiceLevelsRates
        ? _.cloneDeep(newRatesData.selectedServiceLevelsRates)
        : null;
      const newOrdersRatesOptionsData = newRatesData.ordersRatesOptions
        ? _.cloneDeep(newRatesData.ordersRatesOptions)
        : null;
      const newOrdersParcelsData = newRatesData.selectedOrdersBoxes
        ? _.cloneDeep(newRatesData.selectedOrdersBoxes)
        : null;
      const newOrdersMessages: IOrderRatesMessages[] | null = newRatesData.ordersRatesMessages
        ? _.cloneDeep(newRatesData.ordersRatesMessages)
        : null;

      if (!newSelectedRatesData) {
        return;
      }

      // If missing data, initialize empty cache object
      if (!cachedBoxRatesData) {
        const data = {
          ordersRatesOptions: new Map<string, IOrderRateDetails[]>(),
          selectedServiceLevelsRates: new Map<string, TruncatedServiceLevelProviderRatesData[]>(),
          selectedOrdersBoxes: new Map<string, IBoxSizeData>(),
          selectedOrdersMessages: new Map<string, IOrderRatesMessages>(),
        };
        if (this.isBestMatch && carrierId) {
          this.boxesRatesCacheByCarriers.get(carrierId).set(boxId, data);
          cachedBoxRatesData = this.boxesRatesCacheByCarriers.get(carrierId).get(boxId);
        } else {
          this.boxesRatesCache.set(boxId, data);
          cachedBoxRatesData = this.boxesRatesCache.get(boxId);
        }
      }

      // If we received all possible rates data - save it
      if (newOrdersRatesOptionsData) {
        newOrdersRatesOptionsData.forEach((orderRatesOptions) => {
          if (orderRatesOptions.orderId && orderRatesOptions.rates) {
            cachedBoxRatesData.ordersRatesOptions.set(orderRatesOptions.orderId, orderRatesOptions.rates);
          }
        });
      }

      if (newOrdersMessages) {
        newOrdersMessages.forEach((orderMessagesData) => {
          if (orderMessagesData?.orderId) {
            cachedBoxRatesData.selectedOrdersMessages.set(orderMessagesData.orderId, orderMessagesData);
          }
        });
      }

      if (newOrdersParcelsData) {
        const cachedOrdersParcels = cachedBoxRatesData.selectedOrdersBoxes;
        newOrdersParcelsData.forEach((val) => {
          if (val?.orderId && val.box) {
            cachedOrdersParcels.set(val.orderId, val.box);
          }
        });
      }

      // We assume that we always receive optimal rates for all carrier service levels
      newSelectedRatesData.forEach((newServiceLevelData) => {
        if (newServiceLevelData?.serviceLevel) {
          // Initialize cached service level rates array: fetch from cache if exist or set as empty array
          const cachedServiceLevelRatesData =
            cachedBoxRatesData.selectedServiceLevelsRates.get(newServiceLevelData.serviceLevel) ?? [];

          newServiceLevelData.ratesPerProviders?.forEach((newProviderRates) => {
            const cachedProviderRates = cachedServiceLevelRatesData.find(
              (val) => val.provider === newProviderRates.provider,
            );

            // If we have no cached data for particular service level and final provider, then just add this data to array
            if (!cachedProviderRates) {
              cachedServiceLevelRatesData.push(newProviderRates);
            } else {
              this.updateServiceLevelProviderRatesCachedData(cachedProviderRates, newProviderRates);
            }
          });

          cachedBoxRatesData.selectedServiceLevelsRates.set(
            newServiceLevelData.serviceLevel,
            cachedServiceLevelRatesData,
          );

          // Then we filter out 'old' service level rates data (if exist), and push new ones
          // if(newServiceLevelInfo?.ordersRatesDetails) {
          //   let orderNumbers = newServiceLevelInfo.ordersRatesDetails.map(val => val.orderNumber);
          //   // console.log(`Order numbers with new rates: ${orderNumbers}`);
          //   cachedServiceLevelBoxesRates = cachedServiceLevelBoxesRates.filter(val => {
          //     return !orderNumbers?.includes(val.orderNumber);
          //   });
          //   // console.log(`Filtered service level rates from old irrelevant data: ${cachedServiceLevelBoxesRates}`);
          //   cachedServiceLevelBoxesRates = cachedServiceLevelBoxesRates.concat(newServiceLevelInfo.ordersRatesDetails);
          //   // console.log(`Set service level ratesd data. SL: ${newServiceLevelInfo.serviceLevel}, related rates: ${JSON.stringify(cachedServiceLevelBoxesRates)}`);
          //   cachedBoxRatesData.serviceLevelsRates.set(newServiceLevelInfo.serviceLevel, cachedServiceLevelBoxesRates);
          // }
        }
      });
      if (this.isBestMatch && carrierId) {
        this.boxesRatesCacheByCarriers.get(carrierId).set(boxId, cachedBoxRatesData);
      } else {
        this.boxesRatesCache.set(boxId, cachedBoxRatesData);
      }
    } catch (e) {
      console.log('Failed to save box related rates data to cache: ', e);
    }
  }

  private updateServiceLevelProviderRatesCachedData(
    cachedProviderRates: TruncatedServiceLevelProviderRatesData,
    newProviderRates: IServiceLevelProviderChosenRates,
  ) {
    const ratesDetailsToSave = cachedProviderRates.ordersRatesDetails ?? [];
    const ratesOrdersIds = newProviderRates?.ordersRatesDetails?.map((val) => val.orderId);
    ratesDetailsToSave.filter((val) => val?.orderId && !ratesOrdersIds.includes(val.orderId));
    ratesDetailsToSave.push(...newProviderRates?.ordersRatesDetails);

    const ordersWithoutRatesDataToSave = cachedProviderRates.ordersMissingRatesDetails ?? [];
    const missingRatesOrderIds = newProviderRates?.ordersMissingRatesDetails?.map((val) => val.orderId);
    ordersWithoutRatesDataToSave.filter((val) => val?.orderId && !missingRatesOrderIds.includes(val.orderId));
    ordersWithoutRatesDataToSave.push(...newProviderRates?.ordersMissingRatesDetails);
  }

  private getCachedOrdersRatesDataByBoxId(boxId: number): TruncatedRatesData | null {
    try {
      if (!boxId) {
        return null;
      }
      let cachedBoxRatesData: BoxesCachedRates;
      if (this.isBestMatch && this.selectedCarrierId) {
        cachedBoxRatesData = this.boxesRatesCacheByCarriers.get(this.selectedCarrierId)?.get(boxId);
      } else {
        cachedBoxRatesData = this.boxesRatesCache.get(boxId);
      }
      if (!cachedBoxRatesData) {
        return null;
      }

      // Generate orders rates options data
      let resultAllOrderRates: IAllOrderRates[] | null = null;
      let resultOrdersMessages: IOrderRatesMessages[] | null = null;

      const ordersIdsSet = cachedBoxRatesData.ordersRatesOptions?.keys();
      if (ordersIdsSet) {
        const orderIdsArr = Array.from(ordersIdsSet);

        resultAllOrderRates = orderIdsArr.map((orderId) => {
          return {
            orderId: orderId,
            rates: cachedBoxRatesData.ordersRatesOptions.get(orderId),
          };
        });

        resultOrdersMessages = orderIdsArr.map((orderId) => {
          return cachedBoxRatesData.selectedOrdersMessages.get(orderId);
        });
      }

      // Generate orders selected parcels data
      let ordersSelectedParcels: IOrderSelectedBox[] | null = null;
      const orderIdsArr = Array.from(cachedBoxRatesData.selectedOrdersBoxes?.keys() ?? []);
      ordersSelectedParcels = orderIdsArr?.map((orderId) => {
        return {
          orderId: orderId,
          box: cachedBoxRatesData.selectedOrdersBoxes.get(orderId),
        };
      });

      // Fetch box related order service level rates from cache
      const resultServiceLevelsRates: TruncatedServiceLevelRatesData[] = [];
      const serviceLevelsKeysIterable = cachedBoxRatesData.selectedServiceLevelsRates?.keys();
      if (serviceLevelsKeysIterable) {
        const serviceLevelsNamesArr = Array.from(serviceLevelsKeysIterable);
        serviceLevelsNamesArr?.forEach((serviceLevelName) => {
          const serviceLevelRates = cachedBoxRatesData.selectedServiceLevelsRates.get(serviceLevelName);

          resultServiceLevelsRates.push({
            serviceLevel: serviceLevelName,
            ratesPerProviders: serviceLevelRates,
          });
        });
      }

      if (!(resultServiceLevelsRates?.length > 0)) {
        return null;
      }

      return {
        ordersRatesOptions: resultAllOrderRates ?? [],
        selectedServiceLevelsRates: resultServiceLevelsRates,
        selectedOrdersBoxes: ordersSelectedParcels,
        ordersRatesMessages: resultOrdersMessages,
      };
    } catch (e) {
      console.log('Failed to fetch box related order rates from cache: ', e);
      return null;
    }
  }

  addSplitIndexToOrderNumber(order) {
    return order?.splitted
      ? `${order.orderNumber}${getOrderSplitIndicesString(order, 'view', true)}`
      : order?.orderNumber;
  }

  private setRowsLoadingMode(ordersIds: string[], isLoading: boolean) {
    ordersIds.forEach((orderId) => {
      const row = this.rows?.find((row) => row.orderId === orderId);
      if (row) {
        row.isLoadingRateData = isLoading;
      }
    });

    this.isPerformingRatesRetry = isLoading;
  }

  isLoadingRates() {
    const isLoadingSingleRates = this.rows?.find((row) => !!row?.isLoadingRateData);
    return isLoadingSingleRates || this.confirming;
  }

  async onRetryButtonClick(row: ProccessedSingleOrderRate) {
    if (row?.orderId) {
      if (row.isShouldTrySuggestedAddress) {
        const orderShippingData = this.ordersShippingAdditionalData?.find((val) => val.orderId === row.orderId);
        if (orderShippingData) {
          orderShippingData.isShouldTrySuggestedAddress = true;
        }
      }

      const response = await this.getOrdersRates([row.orderId], {
        boxId: row?.boxId,
        carrierId: this.selectedCarrierId,
      });
      if (response?.rateInfo) {
        const orderBatchRateInfo: IOrderBatchRateInfo = response.rateInfo;
        if (orderBatchRateInfo?.totalServiceLevelsRatesData) {
          const newRates = orderBatchRateInfo.totalServiceLevelsRatesData;
          const selectedBoxId = newRates.selectedOrdersBoxes?.find((val) => val?.orderId === row.orderId)?.box?.id;
          if (selectedBoxId) {
            this.updateBoxRatesCacheData(newRates, row.boxId, orderBatchRateInfo?.carrier?.id);
          }
          this.updateNewBoxesAndRatesData([row], newRates);
        }
      } else if (response?.rateInfoList) {
        // Best match approach - retrieving rates for all carriers together
        // TODO: version 2 of best match
        const orderBatchRateInfoList: IOrderBatchRateInfo[] = response.rateInfoList;
      }

      this.rows = [...this.rows];
      if (this.isBestMatch && this.selectedCarrierId) {
        this.rowsByCarriers.set(this.selectedCarrierId, this.rows);
      }
      this.generateAnalyzedBatchData();
    }
  }

  async onErrorBannerRetryClick(orderId: string) {
    const row = this.rows?.find((val) => val?.orderId === orderId);
    if (row) {
      await this.onRetryButtonClick(row);
    }
  }

  private getNonRecommendedServiceLevel(
    recommendedServiceLevelNames: string[],
    carrierServiceLevelInternalToken: string,
    carrierServiceLevelName: string,
  ) {
    return this.selectedServiceLevel === ServiceLevelDisplayNames.PDQ_CHOISE ||
      (this.selectedServiceLevel === mappingDisplayNameToServiceLevel(ServiceLevelDisplayNames.PDQ_CHOISE) &&
        recommendedServiceLevelNames?.length)
      ? recommendedServiceLevelNames?.includes(carrierServiceLevelInternalToken) ||
        recommendedServiceLevelNames.some((name) => name === carrierServiceLevelName)
        ? null
        : carrierServiceLevelName
      : null;
  }

  private getBatchSelectedRatesForOrder(orderId: string, carrierId?: number) {
    let selectedData;
    if (
      this.selectedRatesDetails &&
      (this.selectedServiceLevel === ServiceLevelDisplayNames.PDQ_CHOISE ||
        this.selectedServiceLevel === mappingDisplayNameToServiceLevel(ServiceLevelDisplayNames.PDQ_CHOISE))
    ) {
      const selectedRateFullData = this.selectedRatesDetails?.find((selectedRate) => selectedRate.orderId == orderId);
      const allOrderRates = this.allOrdersRates.find((allOrderRates) => allOrderRates.orderId == orderId);
      selectedData =
        (!this.isBestMatch ||
          selectedRateFullData?.carrierId == this.selectedCarrierId ||
          selectedRateFullData?.carrierId == carrierId) &&
        allOrderRates?.rates?.find(
          (rate) =>
            this.selectedProvider?.toLowerCase() == selectedRateFullData?.provider?.toLowerCase() &&
            rate.provider?.toLowerCase() == selectedRateFullData?.provider?.toLowerCase() &&
            rate.carrierServiceLevelInternalToken == selectedRateFullData?.carrierServiceLevelInternalToken,
        )
          ? selectedRateFullData
          : undefined;
    }
    return selectedData;
  }

  private getIsRecommendedServiceLevelExist(recommendedServiceLevelNames: string[]) {
    return recommendedServiceLevelNames.every((recommendedServiceLevel) =>
      this.allOrdersRates.find((rate) =>
        rate.rates.find((rateItem) => rateItem.carrierServiceLevelInternalToken === recommendedServiceLevel),
      ),
    );
  }

  private getRecommendedServiceLevelNamesForDisplay(recommendedServiceLevelNamesList: any) {
    const recommendedServiceLevelNames = Array.isArray(recommendedServiceLevelNamesList)
      ? recommendedServiceLevelNamesList
      : (recommendedServiceLevelNamesList?.split(',') ?? []);

    return recommendedServiceLevelNames.map((serviceLevel) => {
      let processedServiceLevel = serviceLevel;

      // Here we handle case of PDQ International Service Levels. For some reason, we have some unclear and specific way of
      // generating service levels names, which differs from all other service levels names. Till we understand this legacy code,
      // and can fix it properly, I added this code, in order to show in table only readable chunk of service level name text
      if (serviceLevel?.split?.('|')?.length === 4) {
        processedServiceLevel = serviceLevel.split('|')[2];
      }
      const provider = ServiceLevelToProviderDisplayName.get(processedServiceLevel);
      const displayProvider = carrierProviderDisplayNameMap[provider!];
      let recommendedServiceLevelNamesForDisplay = '';

      if (displayProvider) {
        recommendedServiceLevelNamesForDisplay += `${displayProvider} - `;
      } else if (provider) {
        recommendedServiceLevelNamesForDisplay += `${provider} - `;
      }
      recommendedServiceLevelNamesForDisplay +=
        ServiceLevelToDisplayName.get(processedServiceLevel) ?? processedServiceLevel;
      return recommendedServiceLevelNamesForDisplay;
    });
  }
}
